var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import errorStateImage from "./assets/icon-pivot.png";
var WEB_COMMON_ASSETS_MAP = {
  WEB_COMMON_ERROR_STATE_IMAGE: errorStateImage,
  WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_FORWARD: "interfaceChevronForward",
  WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_BACK: "interfaceChevronBack"
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(WEB_COMMON_ASSETS_MAP);
};

// src/components/assessment-exit-modal/assessment-exit-modal.component.jsx
import React3, { useEffect } from "react";
import PropTypes2 from "prop-types";
import { Transition } from "react-transition-group";
import { Box as Box2, Flex as Flex3, genesisStyled } from "@leagueplatform/genesis-commons";
import { Modal } from "@leagueplatform/ui-kit";
import { getContentUrl } from "@leagueplatform/league-content-api";
import { queryHelpers, useMediaQuery } from "@leagueplatform/genesis-core";

// src/components/cta-media-object/cta-media-object.component.jsx
import React from "react";
import PropTypes from "prop-types";
import {
  BodyOne,
  HeadingOne,
  HeadingTwo,
  Flex,
  Box,
  Image,
  PrimaryButton,
  QuietButton
} from "@leagueplatform/genesis-commons";
import { LinkLegacy as RouterLink } from "@leagueplatform/routing";
var CTAMediaObject = ({
  title,
  description,
  ctaLink,
  ctaText,
  secondaryLink,
  secondaryText,
  image,
  ctaHandler,
  secondaryHandler,
  svg,
  ctaAnalytics,
  secondaryAnalytics,
  eyebrow,
  isMobile
}) => {
  const showSecondaryLink = Boolean(
    secondaryText && (secondaryLink || secondaryHandler)
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Flex,
    {
      flexDirection: { _: "column", tablet: "initial" },
      padding: isMobile ? "0 16px" : "initial",
      marginTop: { _: "-100px", tablet: "0" }
    },
    /* @__PURE__ */ React.createElement(
      Box,
      {
        flex: isMobile ? "none" : "0 0 277px",
        display: { _: "flex", tablet: "initial" },
        justifyContent: { _: "center", tablet: "initial" }
      },
      svg || /* @__PURE__ */ React.createElement(
        Image,
        {
          src: image,
          role: "presentation",
          height: isMobile ? "180px" : "280px"
        }
      )
    ),
    /* @__PURE__ */ React.createElement(
      Flex,
      {
        flexDirection: "column",
        justifyContent: "center",
        marginInlineStart: { _: "0", tablet: "two" },
        textAlign: { _: "center", tablet: "initial" },
        width: "100%"
      },
      eyebrow && eyebrow,
      isMobile ? /* @__PURE__ */ React.createElement(HeadingTwo, { marginBottom: "one", marginTop: "50px" }, title) : /* @__PURE__ */ React.createElement(HeadingOne, { marginBottom: "one" }, title),
      /* @__PURE__ */ React.createElement(BodyOne, null, description)
    )
  ), /* @__PURE__ */ React.createElement(
    Flex,
    {
      marginTop: "four",
      justifyContent: "center",
      width: isMobile ? "100%" : "initial",
      padding: isMobile ? "0 16px" : "initial"
    },
    /* @__PURE__ */ React.createElement(
      Flex,
      {
        alignItems: "center",
        width: isMobile ? "100%" : "initial",
        flexDirection: isMobile ? "column-reverse" : "row"
      },
      showSecondaryLink && /* @__PURE__ */ React.createElement(
        Box,
        {
          marginInlineEnd: { _: "none", tablet: "two" },
          width: { _: "100%", tablet: "auto" }
        },
        /* @__PURE__ */ React.createElement(
          QuietButton,
          {
            as: secondaryLink ? RouterLink : void 0,
            to: secondaryLink,
            width: { _: "100%", tablet: "auto" },
            textDecoration: "none",
            onClick: (e) => {
              if (secondaryHandler) {
                e.preventDefault();
                secondaryHandler();
              }
              secondaryAnalytics();
            }
          },
          secondaryText
        )
      ),
      /* @__PURE__ */ React.createElement(
        PrimaryButton,
        {
          as: ctaLink ? RouterLink : void 0,
          to: ctaLink,
          textDecoration: "none",
          width: isMobile ? "100%" : "initial",
          marginInlineStart: {
            _: "none",
            tablet: !showSecondaryLink ? "80px" : "none"
          },
          onClick: (e) => {
            if (ctaHandler) {
              e.preventDefault();
              ctaHandler();
            }
            ctaAnalytics();
          }
        },
        ctaText
      )
    )
  ));
};
CTAMediaObject.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ctaLink: PropTypes.string,
  secondaryLink: PropTypes.string,
  ctaText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  image: PropTypes.string,
  ctaHandler: PropTypes.func,
  secondaryHandler: PropTypes.func,
  svg: PropTypes.element,
  ctaAnalytics: PropTypes.func,
  secondaryAnalytics: PropTypes.func,
  eyebrow: PropTypes.string,
  isMobile: PropTypes.bool
};
CTAMediaObject.defaultProps = {
  secondaryLink: null,
  secondaryText: "",
  secondaryHandler: null,
  ctaHandler: null,
  ctaLink: null,
  image: "",
  eyebrow: null,
  svg: null,
  ctaAnalytics: () => {
  },
  secondaryAnalytics: () => {
  },
  isMobile: false
};

// src/components/eyebrow-earn-points/eyebrow-earn-points.component.tsx
import React2 from "react";
import { Icon, ICONS } from "@leagueplatform/ui-kit";
import { Overline, Flex as Flex2 } from "@leagueplatform/genesis-commons";
import { useIntl } from "@leagueplatform/locales";
var EyebrowEarnPoints = ({
  completionPoints
}) => {
  const { formatMessage } = useIntl();
  return /* @__PURE__ */ React2.createElement(Flex2, { display: "inline-flex", marginBottom: "half", alignItems: "center" }, /* @__PURE__ */ React2.createElement(Icon, { icon: ICONS.STAR_FILLED, size: 16, "aria-hidden": true }), /* @__PURE__ */ React2.createElement(Overline, { as: "p", marginInlineStart: "half" }, formatMessage(
    { id: "EARN_NUMBER_POINTS_FULL" },
    { points: completionPoints }
  )));
};

// src/components/assessment-exit-modal/assessment-exit-modal.component.jsx
var Fade = genesisStyled.div`
  transition: opacity 400ms ease-in-out;
  opacity: ${({ state }) => state === "entered" ? 1 : 0};
`;
var AssessmentExitModal = ({
  setShowExit,
  exitScreen,
  ctaHandler,
  ctaAnalytics,
  secondaryAnalytics,
  completionPoints,
  sendPageAnalytics
}) => {
  useEffect(() => {
    if (sendPageAnalytics) {
      sendPageAnalytics();
    }
  }, [sendPageAnalytics]);
  const isMobile = useMediaQuery(queryHelpers.down("tablet"));
  return /* @__PURE__ */ React3.createElement(Modal.Wrapper, { onClose: () => setShowExit(false) }, /* @__PURE__ */ React3.createElement(
    Flex3,
    {
      width: "100%",
      height: "100%",
      position: "fixed",
      backgroundColor: "surface.background.primary",
      zIndex: "sticky",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      "aria-live": "assertive"
    },
    /* @__PURE__ */ React3.createElement(Box2, { as: "main", maxWidth: "790px", padding: "twoAndHalf" }, /* @__PURE__ */ React3.createElement(Transition, { timeout: 250, in: true, appear: true, unmountOnExit: true }, (state) => /* @__PURE__ */ React3.createElement(Fade, { state }, /* @__PURE__ */ React3.createElement(
      CTAMediaObject,
      {
        eyebrow: completionPoints > 0 && /* @__PURE__ */ React3.createElement(EyebrowEarnPoints, { completionPoints }),
        title: exitScreen.title,
        description: exitScreen.description,
        ctaHandler,
        secondaryHandler: () => {
          secondaryAnalytics();
          setShowExit(false);
        },
        ctaText: exitScreen.buttonOk,
        secondaryText: exitScreen.buttonNo,
        ctaAnalytics,
        image: exitScreen.image || getContentUrl(exitScreen.imageId),
        isMobile
      }
    ))))
  ));
};
AssessmentExitModal.propTypes = {
  setShowExit: PropTypes2.func.isRequired,
  exitScreen: PropTypes2.shape({
    title: PropTypes2.string.isRequired,
    description: PropTypes2.string.isRequired,
    buttonOk: PropTypes2.string.isRequired,
    buttonNo: PropTypes2.string.isRequired,
    imageId: PropTypes2.string.isRequired,
    image: PropTypes2.string
  }).isRequired,
  ctaHandler: PropTypes2.func,
  ctaAnalytics: PropTypes2.func,
  sendPageAnalytics: PropTypes2.func,
  secondaryAnalytics: PropTypes2.func,
  completionPoints: PropTypes2.number
};
AssessmentExitModal.defaultProps = {
  ctaHandler: null,
  ctaAnalytics: () => void 0,
  secondaryAnalytics: () => void 0,
  sendPageAnalytics: null,
  completionPoints: 0
};

// src/components/dimension-of-health-modal/dimension-of-health-modal.component.tsx
import React4 from "react";
import {
  Box as Box3,
  Flex as Flex4,
  Overline as Overline2,
  HeadingOne as HeadingOne2,
  BodyOne as BodyOne2,
  SubtitleOne,
  genesisStyled as genesisStyled2,
  QuietButton as CloseButton,
  VisuallyHidden,
  Image as Image2
} from "@leagueplatform/genesis-commons";
import { Modal as Modal2, Icon as Icon2, ICONS as ICONS2, useModalA11yProps } from "@leagueplatform/ui-kit";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { openInTab } from "@leagueplatform/web-common";
import { getContentUrl as getContentUrl2 } from "@leagueplatform/league-content-api";
import IconHealthArticle from "./assets/health-article-icon.svg";
import {
  sendAnalyticsEvent,
  usePageViewAnalytics
} from "@leagueplatform/analytics";
var DIMENSION_HEALTH_MODAL_MAX_WIDTH = "574px";
var DIMENSION_HEALTH_MODAL_LABEL = "dimension-of-health-modal";
var getDimensionOfHealthScreenName = (type) => `dimensions of health ${type.toLowerCase()}`;
var InteractiveBox = genesisStyled2(Box3)`
  cursor: pointer;
`;
var DimensionOfHealthModal = ({
  title,
  description,
  imageId,
  icon,
  placeholderImage,
  url,
  onClose,
  analyticsScreenName,
  // Used only for analytics
  analyticsProductArea
}) => {
  const modalAriaProps = useModalA11yProps();
  usePageViewAnalytics(
    {
      product_area: analyticsProductArea,
      screen_name: getDimensionOfHealthScreenName(title),
      has_health_profile: true
    },
    [title]
  );
  const { formatMessage } = useIntl2();
  const healthNeedsImageSrc = imageId ? getContentUrl2(imageId) : placeholderImage;
  const imageSrc = icon || healthNeedsImageSrc;
  return /* @__PURE__ */ React4.createElement(Modal2.Wrapper, { onClose, options: {} }, /* @__PURE__ */ React4.createElement(
    Box3,
    __spreadProps(__spreadValues({
      padding: "four",
      borderRadius: "medium",
      position: "relative",
      overflowY: "scroll",
      backgroundColor: "surface.background.primary",
      maxWidth: DIMENSION_HEALTH_MODAL_MAX_WIDTH
    }, modalAriaProps), {
      "aria-labelledby": DIMENSION_HEALTH_MODAL_LABEL
    }),
    /* @__PURE__ */ React4.createElement(
      CloseButton,
      {
        onClick: onClose,
        paddingX: "half",
        paddingY: "half",
        position: "absolute",
        top: "one",
        insetInlineEnd: "oneAndHalf"
      },
      /* @__PURE__ */ React4.createElement(VisuallyHidden, null, formatMessage({ id: "CLOSE" })),
      /* @__PURE__ */ React4.createElement(Icon2, { icon: ICONS2.CLOSE, size: 20 })
    ),
    imageSrc && /* @__PURE__ */ React4.createElement(
      Flex4,
      {
        justifyContent: "center",
        flexDirection: "column",
        height: 277,
        width: 277,
        margin: "auto"
      },
      /* @__PURE__ */ React4.createElement(Image2, { "data-testid": "dimension-image", src: imageSrc, alt: "" })
    ),
    /* @__PURE__ */ React4.createElement(
      Overline2,
      {
        as: "h1",
        color: "onSurface.text.subdued",
        marginY: "half",
        id: DIMENSION_HEALTH_MODAL_LABEL
      },
      formatMessage({ id: "DIMENSION_OF_HEALTH" })
    ),
    /* @__PURE__ */ React4.createElement(HeadingOne2, { marginBottom: "one", as: "h2" }, title),
    /* @__PURE__ */ React4.createElement(BodyOne2, { marginBottom: "twoAndHalf", color: "onSurface.text.subdued" }, description),
    url && /* @__PURE__ */ React4.createElement(
      Flex4,
      {
        padding: "oneAndHalf",
        borderColor: "interactive.border.disabled",
        borderStyle: "solid",
        borderWidth: "thin",
        borderRadius: "medium"
      },
      /* @__PURE__ */ React4.createElement(Flex4, { justifyContent: "center", width: 100, height: 72 }, /* @__PURE__ */ React4.createElement(Image2, { src: IconHealthArticle, alt: "" })),
      /* @__PURE__ */ React4.createElement(Box3, { marginInlineStart: "oneAndHalf", width: "100%" }, /* @__PURE__ */ React4.createElement(BodyOne2, { color: "onSurface.text.subdued", marginBottom: "half" }, formatMessage({ id: "READING_MORE_ABOUT_DIMENSIONS" })), /* @__PURE__ */ React4.createElement(
        InteractiveBox,
        {
          onClick: () => {
            sendAnalyticsEvent({
              category: analyticsScreenName,
              action: "Read Dimension of Health Article",
              label: title
            });
            openInTab(url);
          }
        },
        /* @__PURE__ */ React4.createElement(SubtitleOne, { color: "onSurface.text.primary" }, formatMessage({ id: "READ_OUR_ARTICLE" }))
      ))
    )
  ));
};

// src/components/document-card/document-card.component.tsx
import * as React5 from "react";
import {
  BodyOne as BodyOne3,
  Box as Box4,
  Caption,
  genesisStyled as genesisStyled3,
  css,
  Flex as Flex5,
  CoverImage,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { SHORT_DATE_FORMAT } from "@leagueplatform/web-common";
import documentIcon from "./assets/documentIcon.svg";
var StyledLink = genesisStyled3(Box4)(
  () => css({
    display: "inline-block",
    paddingX: "threeQuarters",
    paddingY: "one",
    transition: "0.2s all",
    textDecoration: "none",
    width: "100%",
    "&:hover": {
      backgroundColor: "interactive.background.hovered"
    }
  })
);
var WrappedText = genesisStyled3(BodyOne3)`
  overflow-wrap: anywhere;
`;
var DocumentCard = ({
  document: document2,
  icon = documentIcon
}) => {
  const { formatMessage, formatDate } = useIntl3();
  const { fileName, lastUpdatedAt, downloadUrl, uploadedBy } = document2;
  return /* @__PURE__ */ React5.createElement(
    Box4,
    {
      as: "li",
      borderColor: "onSurface.border.subdued",
      borderRadius: "medium",
      borderStyle: "solid",
      borderWidth: "thin"
    },
    /* @__PURE__ */ React5.createElement(StyledLink, { as: "a", href: downloadUrl, rel: "noreferrer", target: "_blank" }, /* @__PURE__ */ React5.createElement(Flex5, { alignItems: "center" }, /* @__PURE__ */ React5.createElement(
      CoverImage,
      {
        src: icon,
        size: "oneAndHalf",
        minWidth: "oneAndHalf",
        alt: "",
        marginInlineEnd: "one"
      }
    ), /* @__PURE__ */ React5.createElement(VisuallyHidden2, null, formatMessage({ id: "VIEW_DOCUMENT" })), /* @__PURE__ */ React5.createElement(Flex5, { flexDirection: "column" }, /* @__PURE__ */ React5.createElement(WrappedText, { as: "span", marginBottom: "quarter" }, fileName), /* @__PURE__ */ React5.createElement(Caption, { as: "span" }, formatMessage(
      { id: "UPLOADED_DOCUMENT" },
      {
        date: formatDate(lastUpdatedAt, SHORT_DATE_FORMAT),
        user: uploadedBy
        // TODO: This uploaded by may get removed
      }
    )))))
  );
};

// src/components/full-page-error/full-page-error.component.tsx
import React8 from "react";
import {
  LinkLegacy as Link,
  useNavigateLegacy as useNavigate
} from "@leagueplatform/routing";
import { Flex as Flex6 } from "@leagueplatform/genesis-commons";

// src/components/error-state/error-state.component.tsx
import React6, { useEffect as useEffect3, useRef } from "react";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import {
  Button,
  HeadingText,
  ImageMessage,
  ParagraphText,
  StackLayout,
  StackItem
} from "@leagueplatform/genesis-core";

// src/hooks/use-display-is-impersonator-error.hook.ts
import { useEffect as useEffect2 } from "react";
import { reportAgentPermissionError } from "@leagueplatform/core";
import { useGetIsImpersonator } from "@leagueplatform/auth-utils";
function isImpersonationError(error) {
  var _a, _b, _c;
  if (error === null)
    return false;
  if (Array.isArray(error)) {
    return error.some((err) => isImpersonationError(err));
  }
  if ((_a = error == null ? void 0 : error.message) == null ? void 0 : _a.includes("403"))
    return true;
  if ((_b = error == null ? void 0 : error.stack) == null ? void 0 : _b.errors) {
    return error.stack.errors.some((err) => (err == null ? void 0 : err.code) === "forbidden");
  }
  if (error == null ? void 0 : error.errors) {
    return error.errors.some((err) => (err == null ? void 0 : err.code) === "forbidden");
  }
  if (typeof (error == null ? void 0 : error.message) === "string") {
    try {
      const parsedError = JSON.parse(error.message);
      if (((_c = parsedError == null ? void 0 : parsedError.info) == null ? void 0 : _c.code) === "unauthorized") {
        return true;
      }
    } catch (e) {
      if (error.message.includes("unauthorized")) {
        return true;
      }
    }
  }
  return false;
}
var useDisplayIsImpersonatorError = ({
  error
}) => {
  const isImpersonationSession = useGetIsImpersonator();
  const showImpersonationError = isImpersonationSession && isImpersonationError(error);
  useEffect2(() => {
    if (showImpersonationError)
      reportAgentPermissionError();
  }, [showImpersonationError]);
  return showImpersonationError;
};

// src/components/error-state/error-state.component.tsx
var defaultTryAgainHandler = () => window.location.reload();
function ErrorContent({
  error,
  buttonText,
  bodyString,
  headingString,
  hideButton = false,
  hideImage,
  onButtonClick = defaultTryAgainHandler,
  labelledbyId,
  describedbyId,
  buttonPriority = "primary",
  emphasisText,
  css: css20
}) {
  const { formatMessage } = useIntl4();
  const buttonRef = useRef(null);
  useEffect3(() => {
    var _a;
    (_a = buttonRef == null ? void 0 : buttonRef.current) == null ? void 0 : _a.focus();
  });
  const showImpersonationError = useDisplayIsImpersonatorError({ error });
  const finalHeadingString = showImpersonationError ? formatMessage({ id: "AGENT_PERMISSION_ERROR" }) : headingString || formatMessage({ id: "THERE_SEEMS_T0_HAVE_BEEN_A_PROBLEM" });
  const shouldHideButton = showImpersonationError ? true : hideButton;
  return /* @__PURE__ */ React6.createElement(
    StackLayout,
    {
      css: __spreadValues({
        marginTop: !hideImage ? "$three" : "none",
        textAlign: "center"
      }, css20),
      horizontalAlignment: "center",
      spacing: "$twoAndHalf"
    },
    /* @__PURE__ */ React6.createElement(StackItem, { className: "error-state-text-wrapper" }, /* @__PURE__ */ React6.createElement(StackLayout, { horizontalAlignment: "center", spacing: "$half" }, /* @__PURE__ */ React6.createElement(
      HeadingText,
      {
        level: "2",
        size: "lg",
        id: labelledbyId,
        className: "error-state-heading-text"
      },
      finalHeadingString
    ), !showImpersonationError && bodyString && /* @__PURE__ */ React6.createElement(ParagraphText, { id: describedbyId, className: "error-state-body-text" }, bodyString)), emphasisText && /* @__PURE__ */ React6.createElement(ParagraphText, { className: "error-state-emphasis-text" }, /* @__PURE__ */ React6.createElement("strong", null, emphasisText))),
    !shouldHideButton && /* @__PURE__ */ React6.createElement(StackItem, { className: "error-state-button-wrapper" }, /* @__PURE__ */ React6.createElement(
      Button,
      {
        onClick: onButtonClick,
        ref: buttonRef,
        priority: buttonPriority,
        className: "error-state-button"
      },
      buttonText || formatMessage({ id: "TRY_AGAIN" })
    ))
  );
}
var ErrorState = (_a) => {
  var _b = _a, {
    hideImage = false,
    imageSrc,
    css: css20
  } = _b, props = __objRest(_b, [
    "hideImage",
    "imageSrc",
    "css"
  ]);
  if (hideImage)
    return /* @__PURE__ */ React6.createElement(ErrorContent, __spreadValues({ css: css20 }, props));
  const errorStateImage2 = handleStaticAsset(
    "WEB_COMMON_ERROR_STATE_IMAGE" /* WEB_COMMON_ERROR_STATE_IMAGE */
  );
  return /* @__PURE__ */ React6.createElement(ImageMessage, { image: imageSrc || errorStateImage2 }, /* @__PURE__ */ React6.createElement(ErrorContent, __spreadValues({ css: css20 }, props)));
};

// src/components/back-button-arrow/back-button-arrow.view.jsx
import React7 from "react";
import PropTypes3 from "prop-types";
import {
  QuietButton as QuietButton2,
  Image as Image3,
  genesisStyled as genesisStyled4,
  css as css2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import BackIcon from "./assets/back.svg";
var BackButton = genesisStyled4(QuietButton2)(
  css2({
    "&:hover, &:active, &:focus": {
      background: "transparent !important",
      transform: "translateX(-3px)",
      "&:dir(rtl)": {
        transform: "translateX(3px)"
      }
    }
  })
);
var Icon3 = genesisStyled4(Image3)(
  css2({
    display: "block",
    width: 24,
    height: 24,
    "&:dir(rtl)": {
      transform: "rotateY(180deg)"
    }
  })
);
var BackButtonArrow = (_a) => {
  var _b = _a, { onClick } = _b, props = __objRest(_b, ["onClick"]);
  const { formatMessage } = useIntl5();
  return /* @__PURE__ */ React7.createElement(
    BackButton,
    __spreadValues({
      onClick,
      backgroundColor: "transparent",
      height: "two",
      minWidth: "two",
      paddingX: "none",
      paddingY: "none"
    }, props),
    /* @__PURE__ */ React7.createElement(Icon3, { src: BackIcon, alt: formatMessage({ id: "GO_BACK" }) })
  );
};
BackButtonArrow.propTypes = {
  onClick: PropTypes3.func
};
BackButtonArrow.defaultProps = {
  onClick: () => {
  }
};

// src/components/full-page-error/full-page-error.component.tsx
var FullPageError = ({ route, error }) => {
  const navigate = useNavigate();
  return /* @__PURE__ */ React8.createElement(
    Flex6,
    {
      flexDirection: { _: "column", phone: "row" },
      height: "100%",
      justifyContent: { _: "flex-start", phone: "center" },
      padding: { _: "oneAndHalf", phone: "twoAndHalf" }
    },
    /* @__PURE__ */ React8.createElement(
      BackButtonArrow,
      {
        as: route && Link,
        justifyContent: "initial",
        marginInlineEnd: "quarter",
        marginY: "half",
        onClick: route ? null : () => {
          navigate(-1);
        },
        to: route,
        size: "three"
      }
    ),
    /* @__PURE__ */ React8.createElement(
      Flex6,
      {
        alignItems: "center",
        justifyContent: "center",
        paddingX: { _: "none", phone: "five" }
      },
      /* @__PURE__ */ React8.createElement(ErrorState, { error })
    )
  );
};

// src/components/page-header-background/page-header-background.tsx
import React9, { useMemo } from "react";
import { Flex as Flex7, genesisStyled as genesisStyled5, css as css3 } from "@leagueplatform/genesis-commons";
import { useConfigProperty } from "@leagueplatform/core";
var DEFAULT_STYLES = {
  height: "140px",
  width: "20024px",
  backgroundColor: "surface.background.tertiary"
};
var StyledPageHeaderBackground = genesisStyled5(Flex7)(
  ({
    pageHeader,
    height = DEFAULT_STYLES.height,
    pageHeaderBackgroundHeight = DEFAULT_STYLES.height
  }) => {
    var _a;
    return css3({
      height,
      backgroundColor: "transparent",
      "&:before": css3({
        backgroundColor: `${(_a = pageHeader == null ? void 0 : pageHeader.backgroundColor) != null ? _a : DEFAULT_STYLES.backgroundColor}`,
        content: '""',
        zIndex: "-1",
        position: "absolute",
        top: `calc(${pageHeaderBackgroundHeight} - ${DEFAULT_STYLES.width})`,
        insetInlineStart: `calc(50% - (${DEFAULT_STYLES.width} / 2))`,
        width: `${DEFAULT_STYLES.width}`,
        height: `${DEFAULT_STYLES.width}`,
        borderRadius: `${(pageHeader == null ? void 0 : pageHeader.shape) === "line" ? 0 : DEFAULT_STYLES.width}`
      })
    });
  }
);
var PageHeaderBackground = (_a) => {
  var _b = _a, {
    height,
    pageHeaderBackgroundHeight,
    className
  } = _b, rest = __objRest(_b, [
    "height",
    "pageHeaderBackgroundHeight",
    "className"
  ]);
  const pageHeaderConfig = useConfigProperty("core.ui.components.pageHeader");
  const composedClassName = useMemo(
    () => ["cc-page-header-background", className].join(" "),
    [className]
  );
  return /* @__PURE__ */ React9.createElement(
    StyledPageHeaderBackground,
    __spreadValues({
      height,
      className: composedClassName,
      pageHeaderBackgroundHeight,
      pageHeader: pageHeaderConfig
    }, rest)
  );
};

// src/components/loading-indicator/loading-indicator.component.tsx
import React10 from "react";
import styled from "styled-components";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { useConfigProperty as useConfigProperty2 } from "@leagueplatform/core";
import { Spinner, genesisStyled as genesisStyled6, Box as Box5 } from "@leagueplatform/genesis-commons";
import { getScopedCssClassnames } from "@leagueplatform/ui-kit";
var LoaderContainer = genesisStyled6(Box5)`
  min-height: 300px;
  position: relative;
  ${(props) => !props.inline && `
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    height: 100%;
    width: 100%;
  `};
`;
var IndicatorContainer = styled.div`
  width: 200px;
  height: 80px;
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
`;
var LoadingText = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
`;
var LoadingIndicator = ({ inline }) => {
  const { formatMessage } = useIntl6();
  const loadingConfig = useConfigProperty2("core.ui.components.loading");
  const loadingComponent = (loadingConfig == null ? void 0 : loadingConfig.element) || /* @__PURE__ */ React10.createElement(Spinner, { isLoading: true, renderLoadingText: false });
  const loadingMessage = (loadingConfig == null ? void 0 : loadingConfig.text) || formatMessage({ id: "LOADING" });
  return /* @__PURE__ */ React10.createElement(LoaderContainer, { inline, className: getScopedCssClassnames() }, /* @__PURE__ */ React10.createElement(IndicatorContainer, null, loadingComponent, (loadingConfig == null ? void 0 : loadingConfig.text) !== false && /* @__PURE__ */ React10.createElement(LoadingText, null, loadingMessage)));
};

// src/components/wrappers-containers/main-page-container.component.tsx
import * as React11 from "react";
import { Flex as Flex8 } from "@leagueplatform/genesis-commons";
import { Box as Box6 } from "@leagueplatform/genesis-core";

// src/components/wrappers-containers/wrappers.constants.ts
var CONTENT_MAX_WIDTH = "1272px";

// src/components/wrappers-containers/main-page-container.component.tsx
var MainPageContainer = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React11.createElement(
    Flex8,
    __spreadValues({
      maxWidth: `var(--content-max-width, ${CONTENT_MAX_WIDTH})`,
      marginX: "auto",
      padding: { _: "oneAndHalf", phone: "two" },
      flexDirection: "column"
    }, props),
    children
  );
};
var PageContainer = ({
  children,
  className,
  css: css20
}) => /* @__PURE__ */ React11.createElement(
  Box6,
  {
    className,
    css: __spreadValues({
      maxWidth: `var(--content-max-width, ${CONTENT_MAX_WIDTH})`,
      marginX: "auto",
      paddingInline: "$oneAndHalf",
      "@mobile": {
        paddingInline: "$two"
      }
    }, css20)
  },
  children
);

// src/components/wrappers-containers/max-width-wrapper.component.tsx
import { Box as Box7, styled as styled2 } from "@leagueplatform/genesis-core";
var MaxWidthWrapper = styled2(Box7, {
  maxWidth: `var(--content-max-width, ${CONTENT_MAX_WIDTH})`,
  margin: "0 auto"
});

// src/components/swoop-header/swoop-header.view.jsx
import React12 from "react";
import PropTypes4 from "prop-types";
import { Box as Box8, QuietButton as QuietButton3, Image as Image4 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl7 } from "@leagueplatform/locales";
import BackIcon2 from "./assets/back.svg";
var SwoopHeader = (_a) => {
  var _b = _a, { onBackClick, children } = _b, props = __objRest(_b, ["onBackClick", "children"]);
  const { formatMessage } = useIntl7();
  return /* @__PURE__ */ React12.createElement(
    PageHeaderBackground,
    __spreadValues({
      paddingX: "twoAndHalf",
      paddingTop: "twoAndHalf",
      marginX: "auto"
    }, props),
    onBackClick !== null && /* @__PURE__ */ React12.createElement(Box8, { marginInlineEnd: "one" }, /* @__PURE__ */ React12.createElement(
      QuietButton3,
      {
        marginTop: 2,
        width: "two",
        height: "two",
        paddingX: 0,
        paddingY: 0,
        borderRadius: "circle",
        onClick: onBackClick
      },
      /* @__PURE__ */ React12.createElement(
        Image4,
        {
          src: BackIcon2,
          position: "relative",
          top: "quarter",
          insetInlineStart: "quarter",
          size: "oneAndHalf",
          alt: formatMessage({ id: "GO_BACK" })
        }
      )
    )),
    children
  );
};
SwoopHeader.propTypes = {
  children: PropTypes4.node.isRequired,
  onBackClick: PropTypes4.func
};
SwoopHeader.defaultProps = {
  onBackClick: null
};

// src/components/user-profile-modal/profile-modal.component.tsx
import React13 from "react";
import {
  Box as Box9,
  QuietButton as QuietButton4,
  genesisStyled as genesisStyled7,
  css as css4,
  VisuallyHidden as VisuallyHidden3,
  Image as Image5
} from "@leagueplatform/genesis-commons";
import { Modal as Modal3 } from "@leagueplatform/ui-kit";
import { useIntl as useIntl8 } from "@leagueplatform/locales";
import CLOSE_ICON from "./assets/close.svg";
var StyledModalContainer = genesisStyled7(Modal3.Container)(
  css4({
    position: "relative",
    maxWidth: 620,
    borderRadius: "medium",
    overflow: "auto"
  })
);
var StyledModalBody = genesisStyled7(Modal3.Body)(
  css4({
    padding: "twoAndHalf"
  })
);
var ProfileModal = ({
  onClose,
  children,
  "aria-labelledby": ariaLabelledBy
}) => {
  const { formatMessage } = useIntl8();
  return /* @__PURE__ */ React13.createElement(Modal3.Wrapper, { options: {}, onClose }, /* @__PURE__ */ React13.createElement(StyledModalContainer, { "aria-labelledby": ariaLabelledBy }, /* @__PURE__ */ React13.createElement(Box9, { position: "absolute", insetInlineEnd: "0" }, /* @__PURE__ */ React13.createElement(QuietButton4, { margin: "one", padding: "half", onClick: onClose }, /* @__PURE__ */ React13.createElement(VisuallyHidden3, null, formatMessage({ id: "CLOSE" })), /* @__PURE__ */ React13.createElement(
    Image5,
    {
      src: CLOSE_ICON,
      role: "presentation",
      size: "threeQuarters",
      "aria-hidden": "true"
    }
  ))), /* @__PURE__ */ React13.createElement(StyledModalBody, null, children)));
};

// src/components/form-fields/field-wrapper.component.jsx
import React14 from "react";
import PropTypes5 from "prop-types";
import { FormattedMessage } from "react-intl";
import {
  breakpoints,
  DottedTooltipModal,
  TooltipHeader,
  Responsive
} from "@leagueplatform/ui-kit";
import {
  Label,
  LabelText,
  Box as Box10,
  ErrorMessage,
  Flex as Flex9
} from "@leagueplatform/genesis-commons";
var FieldWrapper = ({
  label,
  tooltipElement,
  children,
  htmlFor,
  error,
  labelId,
  groupedField
}) => /* @__PURE__ */ React14.createElement(
  Label,
  {
    htmlFor,
    id: labelId,
    as: groupedField ? "fieldset" : "label"
  },
  /* @__PURE__ */ React14.createElement(
    LabelText,
    {
      as: groupedField ? "legend" : void 0,
      justifyContent: "space-between",
      alignItems: "flex-end",
      width: 1,
      marginBottom: "quarter"
    },
    /* @__PURE__ */ React14.createElement(Flex9, null, /* @__PURE__ */ React14.createElement(Box10, { flexGrow: 1 }, label), tooltipElement && /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(Responsive, { breakpoint: breakpoints.lapAndAbove }, /* @__PURE__ */ React14.createElement(
      TooltipHeader,
      {
        tooltipLink: /* @__PURE__ */ React14.createElement(Box10, { fontWeight: "regular" }, /* @__PURE__ */ React14.createElement(FormattedMessage, { id: "WHY_DO_YOU_ASK" })),
        tooltipText: /* @__PURE__ */ React14.createElement(
          Box10,
          {
            minWidth: 350,
            fontSize: "body2",
            fontWeight: "regular",
            color: "onSurface.text.primary"
          },
          tooltipElement
        ),
        verticalPosition: "bottom: 3rem;",
        pointerPosition: 50,
        inline: true
      }
    )), /* @__PURE__ */ React14.createElement(Responsive, { breakpoint: breakpoints.belowLap }, /* @__PURE__ */ React14.createElement(
      DottedTooltipModal,
      {
        label: /* @__PURE__ */ React14.createElement(FormattedMessage, { id: "WHY_DO_YOU_ASK" }),
        content: tooltipElement,
        marginTop: "minusThreeQuarters",
        inline: true
      }
    ))))
  ),
  /* @__PURE__ */ React14.createElement(Box10, null, children),
  error && /* @__PURE__ */ React14.createElement(ErrorMessage, null, error)
);
FieldWrapper.propTypes = {
  label: PropTypes5.oneOfType([PropTypes5.string, PropTypes5.node]).isRequired,
  children: PropTypes5.node.isRequired,
  htmlFor: PropTypes5.string.isRequired,
  tooltipElement: PropTypes5.node,
  labelId: PropTypes5.string,
  error: PropTypes5.oneOfType([
    PropTypes5.bool,
    PropTypes5.string,
    PropTypes5.shape({
      code: PropTypes5.string,
      description: PropTypes5.string
    })
  ]),
  groupedField: PropTypes5.bool
};
FieldWrapper.defaultProps = {
  tooltipElement: null,
  error: null,
  labelId: void 0,
  groupedField: false
};

// src/components/form-fields/input-field.component.jsx
import React20 from "react";
import PropTypes7 from "prop-types";
import { Field } from "formik";

// src/components/form-fields/select-field.component.jsx
import React15 from "react";
import { Select } from "@leagueplatform/genesis-core";
import { useIntl as useIntl9 } from "@leagueplatform/locales";

// src/components/form-fields/field-shape.jsx
import PropTypes6 from "prop-types";
var fieldProps = {
  field: PropTypes6.shape({
    name: PropTypes6.string.isRequired,
    value: PropTypes6.any
  }),
  form: PropTypes6.shape({
    setFieldValue: PropTypes6.func,
    setFieldError: PropTypes6.func,
    setFieldTouched: PropTypes6.func
  }),
  options: PropTypes6.arrayOf(
    PropTypes6.shape({
      label: PropTypes6.string.isRequired,
      value: PropTypes6.any.isRequired
    })
  ),
  placeholder: PropTypes6.string,
  required: PropTypes6.bool,
  disabled: PropTypes6.bool,
  readOnly: PropTypes6.bool,
  hasError: PropTypes6.bool
};

// src/components/form-fields/select-field.component.jsx
var SelectField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name } = _d, field = __objRest(_d, ["name"]), _e = _b, {
    form: { handleBlur, setFieldValue },
    inputId,
    disabled,
    readOnly,
    placeholder
  } = _e, props = __objRest(_e, [
    "field",
    "form",
    "inputId",
    "disabled",
    "readOnly",
    "placeholder"
  ]);
  const { formatMessage } = useIntl9();
  return /* @__PURE__ */ React15.createElement(
    Select,
    __spreadProps(__spreadValues(__spreadValues({}, props), field), {
      name,
      id: inputId,
      placeholder: placeholder != null ? placeholder : formatMessage({ id: "SELECT_ONE" }),
      disabled: Boolean(disabled != null ? disabled : readOnly),
      onBlur: ({ value }) => {
        handleBlur({ target: { value, name } });
      },
      onChange: (evt) => {
        const value = evt ? evt.currentTarget.value : null;
        setFieldValue(name, value);
      },
      "data-testid": `select_field_${name}`
    })
  );
};
SelectField.propTypes = fieldProps;

// src/components/form-fields/text-field.component.jsx
import React16 from "react";
import { TextInput } from "@leagueplatform/genesis-commons";
var TextField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name } = _d, field = __objRest(_d, ["name"]), {
    disabled = false,
    readOnly = false,
    hasError = false,
    required,
    inputId,
    placeholder = null
  } = _b;
  return /* @__PURE__ */ React16.createElement(
    TextInput,
    __spreadProps(__spreadValues({}, field), {
      required,
      name,
      id: inputId,
      disabled: Boolean(disabled != null ? disabled : readOnly),
      error: hasError,
      placeholder
    })
  );
};
TextField.propTypes = fieldProps;

// src/components/form-fields/date-field.component.jsx
import React17 from "react";
import { DateInput } from "@leagueplatform/ui-kit";
var DateField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name } = _d, field = __objRest(_d, ["name"]), _e = _b, {
    form: { setFieldValue, setFieldTouched, setFieldError },
    disabled,
    readOnly
  } = _e, props = __objRest(_e, [
    "field",
    "form",
    "disabled",
    "readOnly"
  ]);
  return /* @__PURE__ */ React17.createElement(
    DateInput,
    __spreadProps(__spreadValues(__spreadValues({}, props), field), {
      name,
      setFieldError,
      onChange: (e, { error }) => {
        setFieldValue(name, error || e.currentTarget.value, !error);
        if (error)
          setFieldError(name, error);
      },
      onBlur: (_, { error }) => {
        setFieldTouched(name, true, !error);
        if (error) {
          setFieldError(name, error);
        }
      },
      disabled: Boolean(disabled != null ? disabled : readOnly)
    })
  );
};
DateField.propTypes = fieldProps;

// src/components/form-fields/multiselect-field.component.jsx
import React18 from "react";
import { MultiSelect } from "@leagueplatform/ui-kit";
var MultiSelectField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name, value } = _d, field = __objRest(_d, ["name", "value"]), _e = _b, {
    form: { setFieldValue },
    disabled,
    readOnly,
    options,
    required
  } = _e, props = __objRest(_e, [
    "field",
    "form",
    "disabled",
    "readOnly",
    "options",
    "required"
  ]);
  var _a2;
  const optionValues = (_a2 = value == null ? void 0 : value.map((option) => {
    var _a3;
    return (_a3 = option == null ? void 0 : option.value) != null ? _a3 : option;
  })) != null ? _a2 : [];
  const selectedValues = optionValues.map(
    (optionValue) => {
      var _a3;
      return (_a3 = options.find((option) => option.value === optionValue)) != null ? _a3 : {
        label: optionValue,
        value: optionValue
      };
    }
  );
  return /* @__PURE__ */ React18.createElement(
    MultiSelect,
    __spreadProps(__spreadValues(__spreadValues({}, props), field), {
      required,
      name,
      options,
      disabled: Boolean(disabled != null ? disabled : readOnly),
      onChange: (selectedOptions, action) => {
        if (!action)
          return;
        const selectedOptionsArray = selectedOptions || [];
        setFieldValue(
          name,
          selectedOptionsArray.map((opt) => opt.value)
        );
      },
      value: selectedValues,
      "data-testid": `multi_select_field_${name}`,
      canCreate: true
    })
  );
};
MultiSelectField.propTypes = fieldProps;

// src/components/form-fields/radio-field.component.jsx
import React19 from "react";
import {
  Radio,
  Label as Label2,
  ChoiceText,
  Flex as Flex10
} from "@leagueplatform/genesis-commons";
var RadioField = (_a) => {
  var _b = _a, {
    field: _c
  } = _b, _d = _c, { name, value } = _d, field = __objRest(_d, ["name", "value"]), {
    form: { setFieldValue },
    inputId,
    required,
    disabled,
    readOnly,
    options,
    hasError
  } = _b;
  const isDisabled = Boolean(disabled != null ? disabled : readOnly);
  const isBooleanField = options.some(
    (option) => typeof option.value === "boolean"
  );
  return /* @__PURE__ */ React19.createElement(
    Flex10,
    {
      alignItems: "center",
      role: "radiogroup",
      "aria-labelledby": `${inputId}_label`,
      id: inputId
    },
    options == null ? void 0 : options.map((option, idx) => /* @__PURE__ */ React19.createElement(
      Label2,
      {
        key: `${name}_${option.value}`,
        marginInlineStart: idx > 0 ? "one" : "none",
        display: "flex",
        paddingTop: "one"
      },
      /* @__PURE__ */ React19.createElement(
        Radio,
        __spreadProps(__spreadValues({}, field), {
          name: inputId,
          value: option.value,
          required,
          disabled: isDisabled,
          checked: option.value === value,
          error: hasError,
          onChange: ({ target }) => {
            const newValue = isBooleanField ? target.value === "true" : target.value;
            setFieldValue(name, newValue);
          }
        })
      ),
      /* @__PURE__ */ React19.createElement(ChoiceText, { marginInlineStart: "threeQuarters" }, option.label)
    ))
  );
};
RadioField.propTypes = fieldProps;

// src/components/form-fields/input-field.constants.js
var TEXT = "text";
var SELECT = "select";
var MULTISELECT = "multiselect";
var RADIO = "radio";
var CHECKBOX = "checkbox";
var DATE = "date";
var HIDDEN = "hidden";

// src/components/form-fields/input-field.component.jsx
var isGroupedField = (fieldType) => [DATE, RADIO].includes(fieldType);
var InputField = (_a) => {
  var _b = _a, {
    inputType,
    name,
    label,
    value,
    required,
    tooltipElement,
    getError,
    formId
  } = _b, otherProps = __objRest(_b, [
    "inputType",
    "name",
    "label",
    "value",
    "required",
    "tooltipElement",
    "getError",
    "formId"
  ]);
  if (!inputType)
    return null;
  if (inputType === HIDDEN)
    return /* @__PURE__ */ React20.createElement(Field, { name }, ({ field }) => /* @__PURE__ */ React20.createElement("input", __spreadProps(__spreadValues({}, field), { type: "hidden" })));
  const error = getError ? getError(name) : otherProps.error;
  const labelId = formId ? `${formId}_${name}_label` : `${name}_label`;
  const inputId = formId ? `${formId}_${name}` : name;
  return /* @__PURE__ */ React20.createElement(
    FieldWrapper,
    __spreadProps(__spreadValues({}, otherProps), {
      label,
      isRequired: required,
      tooltipElement,
      error,
      htmlFor: inputId,
      labelId,
      groupedField: isGroupedField(inputType)
    }),
    /* @__PURE__ */ React20.createElement(Field, { name }, ({ field, form }) => {
      const fieldProps2 = __spreadProps(__spreadValues({}, otherProps), {
        field,
        form,
        inputId,
        hasError: Boolean(error)
      });
      switch (inputType) {
        case TEXT:
          return /* @__PURE__ */ React20.createElement(TextField, __spreadValues({}, fieldProps2));
        case SELECT:
          return /* @__PURE__ */ React20.createElement(SelectField, __spreadValues({}, fieldProps2));
        case MULTISELECT:
          return /* @__PURE__ */ React20.createElement(MultiSelectField, __spreadValues({}, fieldProps2));
        case DATE:
          return /* @__PURE__ */ React20.createElement(DateField, __spreadValues({}, fieldProps2));
        case RADIO:
          return /* @__PURE__ */ React20.createElement(RadioField, __spreadValues({}, fieldProps2));
        default:
          return null;
      }
    })
  );
};
InputField.propTypes = {
  inputType: PropTypes7.string,
  name: PropTypes7.string,
  label: PropTypes7.string,
  formId: PropTypes7.string,
  placeholder: PropTypes7.string,
  required: PropTypes7.bool,
  tooltipElement: PropTypes7.node,
  getError: PropTypes7.func,
  disabled: PropTypes7.bool,
  value: PropTypes7.any
  // eslint-disable-line
};
InputField.defaultProps = {
  inputType: void 0,
  name: void 0,
  label: void 0,
  formId: void 0,
  placeholder: void 0,
  required: false,
  tooltipElement: null,
  disabled: false,
  getError: void 0,
  value: null
};
InputField.displayName = "InputField";

// src/components/form-fields/field-grid.component.jsx
import React21 from "react";
import { Flex as Flex11 } from "@leagueplatform/genesis-commons";
var FieldGrid = (props) => /* @__PURE__ */ React21.createElement(Flex11, __spreadValues({ flexWrap: "wrap" }, props));

// src/components/form-fields/field-section.component.js
import styled3 from "styled-components";
import { vars, Box as Box11 } from "@leagueplatform/ui-kit";
var FieldSection = styled3(Box11)`
  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to right,
      ${vars.colour.white},
      ${vars.colour.navyLightest} 20%,
      ${vars.colour.navyLightest} 80%,
      ${vars.colour.white}
    );
  }
`;

// src/components/opens-in-a-new-tab-message/opens-in-a-new-tab-message.component.tsx
import React22 from "react";
import { VisuallyHidden as VisuallyHidden4 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl10 } from "@leagueplatform/locales";
var OpensInANewTabMessage = () => {
  const { formatMessage } = useIntl10();
  return /* @__PURE__ */ React22.createElement(VisuallyHidden4, null, formatMessage({ id: "OPENS_IN_A_NEW_TAB" }));
};

// src/components/with-hidden-description/with-hidden-description.component.tsx
import * as React23 from "react";
import { VisuallyHidden as VisuallyHidden5 } from "@leagueplatform/genesis-commons";
var WithHiddenDescription = ({
  children,
  description
}) => {
  if (!children)
    return null;
  return /* @__PURE__ */ React23.createElement(React23.Fragment, null, /* @__PURE__ */ React23.createElement("span", { "aria-hidden": "true" }, children), /* @__PURE__ */ React23.createElement(VisuallyHidden5, null, description));
};

// src/components/very-quiet-button/very-quiet-button.component.jsx
import * as React24 from "react";
import { bool } from "prop-types";
import { genesisStyled as genesisStyled8, QuietButton as QuietButton5 } from "@leagueplatform/genesis-commons";
var getTextColor = ({ theme }) => {
  var _a, _b, _c;
  return (_c = (_b = (_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a.onSurface) == null ? void 0 : _b.text) == null ? void 0 : _c.primary;
};
var getBackgroundColor = ({ theme, darkenBackground }) => {
  var _a, _b, _c, _d, _e, _f;
  return darkenBackground ? (_c = (_b = (_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a.surface) == null ? void 0 : _b.background) == null ? void 0 : _c.secondary : (_f = (_e = (_d = theme == null ? void 0 : theme.colors) == null ? void 0 : _d.surface) == null ? void 0 : _e.background) == null ? void 0 : _f.primary;
};
var getTextDecoration = ({ hideUnderline }) => hideUnderline ? "inherit" : "underline";
var StyledQuietButton = genesisStyled8(QuietButton5)`
  &:hover, &:focus {
    text-decoration: ${getTextDecoration};
    background-color: ${getBackgroundColor};
    color: ${getTextColor};
  }
`;
var VeryQuietButton = (_a) => {
  var _b = _a, {
    darkenBackground = false,
    hideUnderline = false
  } = _b, props = __objRest(_b, [
    "darkenBackground",
    "hideUnderline"
  ]);
  return /* @__PURE__ */ React24.createElement(
    StyledQuietButton,
    __spreadValues({
      darkenBackground,
      hideUnderline
    }, props)
  );
};
VeryQuietButton.propTypes = {
  hideUnderline: bool,
  darkenBackground: bool
};
VeryQuietButton.defaultProps = {
  hideUnderline: false,
  darkenBackground: false
};

// src/components/status-badge/status-badge.component.tsx
import React25 from "react";
import {
  Flex as Flex12,
  Box as Box12,
  SubtitleTwo,
  Caption as Caption2,
  VisuallyHidden as VisuallyHidden6
} from "@leagueplatform/genesis-commons";
var STATUS_OPTIONS = /* @__PURE__ */ ((STATUS_OPTIONS2) => {
  STATUS_OPTIONS2["SUCCESS"] = "SUCCESS";
  STATUS_OPTIONS2["HIGHLIGHT"] = "HIGHLIGHT";
  STATUS_OPTIONS2["WARNING"] = "WARNING";
  STATUS_OPTIONS2["CRITICAL"] = "CRITICAL";
  STATUS_OPTIONS2["DISABLED"] = "DISABLED";
  return STATUS_OPTIONS2;
})(STATUS_OPTIONS || {});
var colorScheme = {
  SUCCESS: {
    backgroundColor: "success.background.subdued",
    iconColor: "success.icon"
  },
  HIGHLIGHT: {
    backgroundColor: "highlight.background.subdued",
    iconColor: "highlight.icon"
  },
  WARNING: {
    backgroundColor: "warning.background.subdued",
    iconColor: "warning.icon"
  },
  CRITICAL: {
    backgroundColor: "critical.background.subdued",
    iconColor: "critical.icon"
  },
  DISABLED: {
    backgroundColor: "surface.card.disabled",
    iconColor: "interactive.icon.disabled"
  }
};
var getStatusColors = (status) => colorScheme[status];
var StatusBadge = ({
  status,
  label,
  displayIcon,
  smallText,
  accessibleDescription
}) => {
  const { backgroundColor, iconColor } = getStatusColors(status);
  return /* @__PURE__ */ React25.createElement(
    Flex12,
    {
      width: "fit-content",
      alignItems: "center",
      paddingX: "half",
      paddingY: "quarter",
      backgroundColor,
      borderRadius: "pill"
    },
    displayIcon && /* @__PURE__ */ React25.createElement(
      Box12,
      {
        height: 10,
        width: 10,
        minWidth: 10,
        backgroundColor: iconColor,
        borderRadius: "circle",
        marginInlineEnd: "quarter",
        role: "presentation"
      }
    ),
    smallText ? /* @__PURE__ */ React25.createElement(Caption2, null, /* @__PURE__ */ React25.createElement(VisuallyHidden6, null, accessibleDescription, "\xA0"), label) : /* @__PURE__ */ React25.createElement(SubtitleTwo, { as: "p" }, /* @__PURE__ */ React25.createElement(VisuallyHidden6, null, accessibleDescription, "\xA0"), label)
  );
};

// src/components/pill-tabs/pill-tabs.component.tsx
import * as React26 from "react";
import {
  Tabs as T,
  Button as Button2
} from "@leagueplatform/genesis-core";
function PillTabList(_a) {
  var _b = _a, { children, css: css20 } = _b, props = __objRest(_b, ["children", "css"]);
  return /* @__PURE__ */ React26.createElement(
    T.TabList,
    __spreadValues({
      css: {
        "[role=tablist]": __spreadValues({
          backgroundColor: "$surfaceBackgroundPrimary",
          borderColor: "$highlightBackgroundSubdued",
          borderRadius: "$pill",
          borderWidth: "$thin",
          boxShadow: "$card",
          padding: "$half $quarter $half $half"
        }, css20)
      },
      tabDistribution: "hugContents"
    }, props),
    children
  );
}
function PillTab(_a) {
  var _b = _a, {
    value,
    children,
    css: css20
  } = _b, props = __objRest(_b, [
    "value",
    "children",
    "css"
  ]);
  const [isTabSelected, setTabSelectedState] = React26.useState(false);
  const tabRef = React26.useCallback((node) => {
    if (node !== null) {
      setTabSelectedState(node.getAttribute("data-state") === "active");
    }
  }, []);
  return /* @__PURE__ */ React26.createElement(
    Button2,
    __spreadValues({
      as: T.Tab,
      value,
      css: __spreadValues({
        borderRadius: "$pill",
        fontSize: "$subtitleTwo",
        marginInlineEnd: "$quarter",
        padding: "$quarter $threeQuarters",
        '&[class*="GDS"]:focus': {
          outlineOffset: "$borderWidths$outerFocus"
        },
        "&[data-state=active]": {
          backgroundColor: "$interactiveActionPrimary",
          color: "$onSurfaceTextReversed",
          borderBottomColor: "transparent"
        },
        "&[data-state=inactive]": {
          color: "$onSurfaceTextSubdued",
          "&:hover": {
            backgroundColor: "$decorativeBrandPrimaryPastel",
            color: "$onSurfaceTextPrimary"
          }
        }
      }, css20),
      size: "small",
      ref: tabRef,
      quiet: !isTabSelected,
      priority: isTabSelected ? "primary" : "secondary"
    }, props),
    children
  );
}
function PillTabs(_a) {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React26.createElement(
    T.Root,
    __spreadValues({
      activationMode: "manual",
      css: {
        "& .GDS-tab-list-wrapper": {
          overflow: "unset"
        }
      }
    }, props),
    children
  );
}

// src/components/accordion/accordion-root.component.tsx
import React27, { useMemo as useMemo2 } from "react";
import * as RadixAccordionPrimitive from "@radix-ui/react-accordion";
import { Box as Box13 } from "@leagueplatform/genesis-core";
var accordionRootStyles = {
  "> * + *": {
    marginTop: "$two"
  },
  "> * > * + *": {
    marginTop: "$one"
  },
  ".cc-accordion-trigger": {
    background: "none",
    color: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    padding: "$quarter $none",
    width: "100%",
    "&:hover, &:focus": {
      background: "none",
      color: "inherit"
    },
    "> span": {
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    ".cc-accordion-trigger-icon": {
      transition: "transform 200ms",
      marginInlineEnd: "$minusHalf"
    },
    "&[aria-expanded=true] .cc-accordion-trigger-icon": {
      transform: "rotate(180deg)"
    }
  }
};
var Root2 = React27.forwardRef((_a, forwardedRef) => {
  var _b = _a, { className, css: css20 } = _b, props = __objRest(_b, ["className", "css"]);
  const composedClassName = useMemo2(
    () => ["cc-accordion", "cc-accordion-root", className].join(" "),
    [className]
  );
  const composedCss = useMemo2(
    () => __spreadValues(__spreadValues({}, accordionRootStyles), css20),
    [css20]
  );
  return /* @__PURE__ */ React27.createElement(
    Box13,
    __spreadProps(__spreadValues({}, props), {
      as: RadixAccordionPrimitive.Root,
      className: composedClassName,
      css: composedCss,
      ref: forwardedRef
    })
  );
});
Root2.displayName = "Accordion.Root";

// src/components/accordion/accordion-item.component.tsx
import React28, { useMemo as useMemo3 } from "react";
import * as RadixAccordionPrimitive2 from "@radix-ui/react-accordion";
import { Box as Box14 } from "@leagueplatform/genesis-core";
var AccordionItemContext = React28.createContext({
  itemId: "",
  triggerId: "",
  contentId: ""
});
var Item2 = React28.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, { className, value } = _b, props = __objRest(_b, ["className", "value"]);
    const context = useMemo3(
      () => ({
        itemId: value,
        triggerId: `${value}-trigger`,
        contentId: `${value}-content`
      }),
      [value]
    );
    const composedClassName = useMemo3(
      () => ["cc-accordion-item", className].join(" "),
      [className]
    );
    return /* @__PURE__ */ React28.createElement(AccordionItemContext.Provider, { value: context }, /* @__PURE__ */ React28.createElement(
      Box14,
      __spreadProps(__spreadValues({}, props), {
        as: RadixAccordionPrimitive2.Item,
        className: composedClassName,
        ref: forwardedRef,
        value
      })
    ));
  }
);
Item2.displayName = "Accordion.Item";

// src/components/accordion/accordion-header.component.tsx
import React29, { useMemo as useMemo4 } from "react";
import * as RadixAccordionPrimitive3 from "@radix-ui/react-accordion";
import { HeadingText as HeadingText2 } from "@leagueplatform/genesis-core";
var Header2 = React29.forwardRef((_a, forwardedRef) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const composedClassName = useMemo4(
    () => ["cc-accordion-header", className].join(" "),
    [className]
  );
  return /* @__PURE__ */ React29.createElement(RadixAccordionPrimitive3.Header, { asChild: true }, /* @__PURE__ */ React29.createElement(
    HeadingText2,
    __spreadProps(__spreadValues({}, props), {
      className: composedClassName,
      ref: forwardedRef
    })
  ));
});
Header2.displayName = "Accordion.Header";

// src/components/accordion/accordion-trigger.component.tsx
import React30, { useMemo as useMemo5 } from "react";
import * as RadixAccordionPrimitive4 from "@radix-ui/react-accordion";
import {
  Box as Box15,
  Button as Button3,
  Icon as Icon4
} from "@leagueplatform/genesis-core";
var Trigger2 = React30.forwardRef((_a, forwardedRef) => {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  const { triggerId, contentId } = React30.useContext(AccordionItemContext);
  const composedClassName = useMemo5(
    () => ["cc-accordion-trigger", className].join(" "),
    [className]
  );
  return /* @__PURE__ */ React30.createElement(
    Button3,
    __spreadProps(__spreadValues({}, props), {
      "aria-controls": contentId,
      as: RadixAccordionPrimitive4.Trigger,
      className: composedClassName,
      id: triggerId,
      ref: forwardedRef
    }),
    /* @__PURE__ */ React30.createElement(Box15, { as: "span" }, children),
    /* @__PURE__ */ React30.createElement(Icon4, { icon: "interfaceChevronDown", className: "cc-accordion-trigger-icon" })
  );
});
Trigger2.displayName = "Accordion.Trigger";

// src/components/accordion/accordion-content.component.tsx
import React31, { useMemo as useMemo6 } from "react";
import * as RadixAccordionPrimitive5 from "@radix-ui/react-accordion";
import { Box as Box16 } from "@leagueplatform/genesis-core";
var Content2 = React31.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    const { triggerId, contentId } = React31.useContext(AccordionItemContext);
    const composedClassName = useMemo6(
      () => ["cc-accordion-content", className].join(" "),
      [className]
    );
    return /* @__PURE__ */ React31.createElement(
      Box16,
      __spreadProps(__spreadValues({}, props), {
        "aria-labelledby": triggerId,
        as: RadixAccordionPrimitive5.Content,
        className: composedClassName,
        id: contentId,
        ref: forwardedRef
      })
    );
  }
);
Content2.displayName = "Accordion.Content";

// src/components/accordion/accordion.component.tsx
var Accordion = {
  Root: Root2,
  Item: Item2,
  Header: Header2,
  Trigger: Trigger2,
  Content: Content2
};

// src/components/carousel/carousel.component.tsx
import React36, { useRef as useRef2, useEffect as useEffect4, useState as useState2, useCallback as useCallback2 } from "react";
import {
  Flex as Flex14,
  css as css6,
  genesisStyled as genesisStyled10,
  Box as Box17,
  BodyOne as BodyOne4
} from "@leagueplatform/genesis-commons";
import {
  useSwipeGestures,
  SWIPE_ORIENTATION,
  SWIPE_DIRECTION
} from "@leagueplatform/web-common";
import { tween, easing } from "popmotion";
import { useTextDirectionality } from "@leagueplatform/genesis-core";

// src/components/carousel/carousel-cta-link.component.tsx
import React33 from "react";

// src/components/internal-or-external-link-button/internal-or-external-link-button.component.tsx
import React32, { forwardRef } from "react";
import { LinkLegacy as Link2 } from "@leagueplatform/routing";
import {
  Button as Button4
} from "@leagueplatform/genesis-core";
import { isExternalUrl } from "@leagueplatform/web-common";
import { useConfigProperty as useConfigProperty3 } from "@leagueplatform/core";
var InternalOrExternalLinkButton = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      href,
      children,
      baseComponent,
      disableDefaultOnClick,
      onClick
    } = _b, linkProps = __objRest(_b, [
      "href",
      "children",
      "baseComponent",
      "disableDefaultOnClick",
      "onClick"
    ]);
    const { isExternalUrl: isExternalLink = isExternalUrl(href) } = linkProps;
    const isExternalUrlOrPhoneNumber = isExternalLink || href.includes("tel:");
    const Component = baseComponent != null ? baseComponent : Button4;
    const handleLink = useConfigProperty3("core.customMethods.handleLink");
    return /* @__PURE__ */ React32.createElement(
      Component,
      __spreadValues({
        ref,
        as: isExternalUrlOrPhoneNumber ? "a" : Link2,
        to: isExternalUrlOrPhoneNumber ? void 0 : href,
        href: isExternalUrlOrPhoneNumber ? href : void 0,
        target: isExternalLink ? "_blank" : void 0,
        rel: isExternalLink ? "noopener noreferrer" : void 0,
        onClick: (e) => {
          if (isExternalLink && !disableDefaultOnClick) {
            e.preventDefault();
            handleLink(href);
          }
          if (onClick) {
            onClick(e);
          }
        }
      }, linkProps),
      children
    );
  }
);

// src/components/carousel/carousel-cta-link.component.tsx
import { TextAction as TextAction2 } from "@leagueplatform/genesis-core";
var CTALink = ({
  children,
  ariaLabel,
  href,
  onClick
}) => /* @__PURE__ */ React33.createElement(
  InternalOrExternalLinkButton,
  {
    baseComponent: TextAction2,
    href,
    onClick,
    "aria-label": ariaLabel
  },
  children
);

// src/components/carousel/carousel-progress-dots.component.tsx
import React34 from "react";
import { Flex as Flex13, genesisStyled as genesisStyled9, css as css5 } from "@leagueplatform/genesis-commons";
var ProgressDot = genesisStyled9(Flex13)(
  ({ isActive }) => css5({
    height: "threeQuarters",
    width: "threeQuarters",
    cursor: "pointer",
    backgroundColor: isActive ? "interactive.action.primary" : "interactive.action.disabled"
  })
);
var ProgressDots = ({ length, currentDot }) => {
  const progressDots = new Array(length).fill(true);
  return /* @__PURE__ */ React34.createElement(
    Flex13,
    {
      position: "absolute",
      flexDirection: "row",
      justify: "center",
      align: "center",
      bottom: "0",
      width: "100%",
      justifyContent: "center"
    },
    progressDots.map((active, index) => {
      const key = `progress-dot-${index}-${active}`;
      return /* @__PURE__ */ React34.createElement(
        ProgressDot,
        {
          borderRadius: "circle",
          marginX: "threeQuarters",
          isActive: currentDot === index,
          key
        }
      );
    })
  );
};

// src/components/carousel/carousel-nav-button.component.tsx
import React35 from "react";
import { SubtleButton } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl11 } from "@leagueplatform/locales";
import { ICONS as ICONS3 } from "@leagueplatform/ui-kit";
import { VisuallyHidden as VisuallyHidden7 } from "@leagueplatform/genesis-core";
var NavButton = ({ disabled, onClick, label, icon }) => /* @__PURE__ */ React35.createElement(
  SubtleButton,
  {
    borderRadius: "circle",
    width: "two",
    height: "two",
    paddingX: "none",
    paddingY: "none",
    paddingTop: "one",
    paddingBottom: "threeQuarters",
    transition: "visibility 300ms, opacity 300ms",
    disabled,
    onClick
  },
  icon,
  /* @__PURE__ */ React35.createElement(VisuallyHidden7, null, label)
);
var BackNavButton = ({
  disabled,
  onClick
}) => {
  const { formatMessage } = useIntl11();
  return /* @__PURE__ */ React35.createElement(
    NavButton,
    {
      disabled,
      onClick,
      label: formatMessage({ id: "PREVIOUS" }),
      icon: ICONS3.BACK_CHEVRON[0]
    }
  );
};
var ForwardNavButton = ({
  disabled,
  onClick
}) => {
  const { formatMessage } = useIntl11();
  return /* @__PURE__ */ React35.createElement(
    NavButton,
    {
      disabled,
      onClick,
      label: formatMessage({ id: "NEXT" }),
      icon: ICONS3.FORWARD_CHEVRON[0]
    }
  );
};

// src/components/carousel/carousel.component.tsx
var shouldShowNavigation = ({
  clientWidth,
  scrollWidth
}) => scrollWidth > clientWidth;
var CarouselInnerWrapper = genesisStyled10(Flex14)(
  ({ spaceBetweenCards }) => css6({
    "& > *": {
      marginInlineEnd: spaceBetweenCards,
      "&:last-child": {
        marginInlineEnd: 0
      }
    }
  })
);
var Carousel = ({
  name,
  children,
  spaceBetweenCards = "one",
  heading,
  description,
  linkOnClick,
  linkAriaLabel,
  linkCta,
  linkUrl,
  BackNavButtonAnalyticsFn: originalBackNavButtonAnalyticsFn,
  ForwardNavButtonAnalyticsFn: originalForwardNavButtonAnalytics,
  LeftNavButtonAnalyticsFn,
  RightNavButtonAnalyticsFn,
  sideArrows = false,
  showProgressDots = false,
  onIndexChange,
  titleMarginBottom = "oneAndHalf"
}) => {
  const BackNavButtonAnalyticsFn = originalBackNavButtonAnalyticsFn || LeftNavButtonAnalyticsFn || (() => null);
  const ForwardNavButtonAnalyticsFn = originalForwardNavButtonAnalytics || RightNavButtonAnalyticsFn || (() => null);
  const dir = useTextDirectionality();
  const carouselRef = useRef2(null);
  const childrenRef = useRef2([]);
  const [forwardArrowDisabled, setForwardArrowDisabled] = useState2(true);
  const [backArrowDisabled, setBackArrowDisabled] = useState2(true);
  const [showNavButtons, setShowNavButtons] = useState2(true);
  const swipeDirection = useSwipeGestures(
    carouselRef,
    SWIPE_ORIENTATION.horizontal
  );
  const [currentProgressIndex, setCurrentProgressIndex] = useState2(0);
  const childrenLength = React36.Children.toArray(children).length;
  const [childrenInView, setChildrenInView] = useState2([]);
  const currentCarouselProperties = () => {
    const { current: currentCarouselRef } = carouselRef;
    if (currentCarouselRef) {
      const { scrollLeft, offsetWidth, scrollWidth } = currentCarouselRef;
      const scrollAmt = Math.ceil(Math.abs(scrollLeft));
      const firstChild = currentCarouselRef.children[0];
      const childrenWidth = firstChild.offsetWidth + parseInt(getComputedStyle(firstChild).marginInlineEnd, 10);
      const currentIndex = parseInt((scrollAmt / childrenWidth).toString(), 10);
      const amountOfChildrenInView = Math.round(offsetWidth / childrenWidth);
      const userScroll = offsetWidth + scrollAmt;
      return {
        currentCarouselRef,
        scrollAmt,
        offsetWidth,
        scrollWidth,
        userScroll,
        firstChild,
        childrenWidth,
        currentIndex,
        amountOfChildrenInView
      };
    }
    return null;
  };
  const updateChildrenInView = useCallback2(() => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const { amountOfChildrenInView, currentIndex, userScroll, scrollWidth } = carouselProperties;
      const lastChildOffset = childrenLength > 1 && userScroll > scrollWidth ? 1 : 0;
      const currentChildIndex = currentIndex + lastChildOffset;
      if (amountOfChildrenInView === 1)
        return setChildrenInView([currentChildIndex]);
      const inView = [];
      for (let x = 0; x < amountOfChildrenInView; x += 1) {
        inView.push(currentChildIndex + x);
      }
      setChildrenInView(inView);
    }
    return null;
  }, [childrenLength]);
  const updateChildrenTabIndex = useCallback2(() => {
    childrenRef.current.forEach((elementRef, index) => {
      var _a, _b;
      const elementInView = childrenInView.find((el) => el === index);
      if (elementInView !== void 0) {
        (_a = elementRef.querySelector('*[tabindex="-1"]')) == null ? void 0 : _a.setAttribute("tabindex", "0");
      } else {
        (_b = elementRef.querySelector('*[tabindex="0"]')) == null ? void 0 : _b.setAttribute("tabindex", "-1");
      }
    });
  }, [childrenInView, childrenRef]);
  const scrollingEvent = useCallback2(() => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const { scrollAmt, scrollWidth, userScroll } = carouselProperties;
      setBackArrowDisabled(scrollAmt === 0);
      setForwardArrowDisabled(userScroll >= scrollWidth);
    }
  }, []);
  useEffect4(() => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const { scrollWidth, offsetWidth, currentCarouselRef } = carouselProperties;
      setForwardArrowDisabled(scrollWidth <= offsetWidth);
      currentCarouselRef.addEventListener("scroll", scrollingEvent);
      setShowNavButtons(shouldShowNavigation(currentCarouselRef));
      childrenRef.current = childrenRef.current.slice(0, childrenLength);
      updateChildrenInView();
      return () => {
        currentCarouselRef.removeEventListener("scroll", scrollingEvent);
      };
    }
    return () => null;
  }, [children, childrenLength, scrollingEvent, updateChildrenInView]);
  useEffect4(() => {
    updateChildrenTabIndex();
  }, [childrenInView, updateChildrenTabIndex]);
  const onResizeCarousel = useCallback2(() => {
    const { current: currentCarouselRef } = carouselRef;
    if (currentCarouselRef) {
      const showNavigation = shouldShowNavigation(currentCarouselRef);
      if (showNavigation !== showNavButtons) {
        setShowNavButtons(showNavigation);
        currentCarouselRef.dispatchEvent(
          new CustomEvent("scroll", { detail: { scrollLeft: 0 } })
        );
      }
    }
  }, [showNavButtons, carouselRef]);
  useEffect4(() => {
    const { current: currentCarouselRef } = carouselRef;
    if (currentCarouselRef) {
      const carouselResize = new ResizeObserver(onResizeCarousel);
      carouselResize.observe(currentCarouselRef);
      return () => {
        carouselResize.disconnect();
      };
    }
    return () => null;
  }, [carouselRef, onResizeCarousel]);
  useEffect4(() => {
    if (onIndexChange) {
      if (currentProgressIndex < 0 || currentProgressIndex >= childrenLength)
        return;
      onIndexChange(currentProgressIndex);
    }
  }, [childrenLength, currentProgressIndex, onIndexChange]);
  const scrollTo = (amt = 0, duration = 0) => {
    const { current: currentCarouselRef } = carouselRef;
    const to = dir === "ltr" ? amt : -amt;
    if (currentCarouselRef) {
      const from = currentCarouselRef.scrollLeft;
      const scroll = tween({
        from,
        to,
        duration,
        ease: easing.easeOut
      });
      scroll.start({
        update: (left) => {
          currentCarouselRef.scrollLeft = left;
        },
        complete: () => {
          updateChildrenInView();
        }
      });
    }
  };
  const handleNavButtonEvent = (type) => {
    const carouselProperties = currentCarouselProperties();
    if (carouselProperties) {
      const { currentIndex, amountOfChildrenInView, childrenWidth, scrollAmt } = carouselProperties;
      if (type === "FORWARD" /* forward */) {
        scrollTo((currentIndex + amountOfChildrenInView) * childrenWidth, 200);
        setCurrentProgressIndex(currentIndex + 1);
      } else if (type === "BACK" /* back */) {
        scrollTo(
          scrollAmt % childrenWidth === 0 ? (currentIndex - amountOfChildrenInView) * childrenWidth : currentIndex * childrenWidth,
          200
        );
        setCurrentProgressIndex((prevIndex) => prevIndex - 1);
      }
    }
  };
  const BackNavButtonEvent = () => {
    handleNavButtonEvent("BACK" /* back */);
    BackNavButtonAnalyticsFn();
  };
  const ForwardNavButtonEvent = () => {
    handleNavButtonEvent("FORWARD" /* forward */);
    ForwardNavButtonAnalyticsFn();
  };
  useEffect4(() => {
    if (swipeDirection) {
      switch (swipeDirection) {
        case SWIPE_DIRECTION.right:
          if (dir === "ltr") {
            ForwardNavButtonEvent();
          } else {
            BackNavButtonEvent();
          }
          break;
        case SWIPE_DIRECTION.left:
          if (dir === "ltr") {
            BackNavButtonEvent();
          } else {
            ForwardNavButtonEvent();
          }
          break;
        default:
          break;
      }
    }
  }, [swipeDirection]);
  if (children === void 0) {
    console.warn(`No children found for carousel: ${name}`);
    return null;
  }
  if (!!linkUrl && linkCta === void 0 || !!linkCta && linkUrl === void 0) {
    if (linkCta === void 0) {
      console.warn(
        `Link CTA will not render. "linkUrl" prop provided, but "linkCta" prop missing for carousel: ${name}. Please provide both props.`
      );
    } else {
      console.warn(
        `Link CTA will not render. "linkCta" prop provided, but "linkUrl" prop missing for carousel: ${name}. Please provide both props.`
      );
    }
  }
  let descriptionWrapper = description;
  if (description && typeof description === "string") {
    descriptionWrapper = /* @__PURE__ */ React36.createElement(BodyOne4, { color: "onSurface.text.subdued" }, description);
  }
  return /* @__PURE__ */ React36.createElement(Flex14, { flexDirection: "column", overflow: "hidden", "data-testid": "carousel" }, /* @__PURE__ */ React36.createElement(Box17, { marginBottom: titleMarginBottom }, /* @__PURE__ */ React36.createElement(
    Flex14,
    {
      alignItems: "center",
      justifyContent: heading ? "space-between" : "flex-end"
    },
    heading,
    /* @__PURE__ */ React36.createElement(
      Flex14,
      {
        marginInlineStart: "threeQuarters",
        alignItems: "center",
        flexDirection: { _: "column", phone: "row" },
        columnGap: "oneAndHalf",
        rowGap: "threeQuarters"
      },
      linkCta && linkUrl && /* @__PURE__ */ React36.createElement(
        CTALink,
        {
          onClick: linkOnClick,
          ariaLabel: linkAriaLabel,
          href: linkUrl
        },
        linkCta
      ),
      showNavButtons && !sideArrows && /* @__PURE__ */ React36.createElement(Flex14, { paddingY: "quarter", columnGap: "one", marginInlineEnd: "4px" }, /* @__PURE__ */ React36.createElement(
        BackNavButton,
        {
          disabled: backArrowDisabled,
          onClick: BackNavButtonEvent
        }
      ), /* @__PURE__ */ React36.createElement(
        ForwardNavButton,
        {
          disabled: forwardArrowDisabled,
          onClick: ForwardNavButtonEvent
        }
      ))
    )
  ), descriptionWrapper), /* @__PURE__ */ React36.createElement(
    Flex14,
    {
      width: "100%",
      justifyContent: "space-between",
      minWidth: "100%",
      position: "relative"
    },
    /* @__PURE__ */ React36.createElement(
      CarouselInnerWrapper,
      {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        as: "ul",
        ref: carouselRef,
        spaceBetweenCards,
        paddingBottom: showProgressDots ? "four" : "quarter",
        padding: "quarter"
      },
      React36.Children.map(children, (child, index) => /* @__PURE__ */ React36.createElement(
        "li",
        {
          ref: (element) => {
            if (element !== null) {
              childrenRef.current[index] = element;
            }
            return null;
          }
        },
        child
      ))
    ),
    sideArrows && showNavButtons && /* @__PURE__ */ React36.createElement(
      Flex14,
      {
        position: "absolute",
        insetInlineStart: "one",
        top: "50%",
        zIndex: 1,
        transform: "translateY(-50%)"
      },
      /* @__PURE__ */ React36.createElement(
        BackNavButton,
        {
          disabled: backArrowDisabled,
          onClick: BackNavButtonEvent
        }
      )
    ),
    sideArrows && showNavButtons && /* @__PURE__ */ React36.createElement(
      Flex14,
      {
        position: "absolute",
        insetInlineEnd: "one",
        top: "50%",
        zIndex: 1,
        transform: "translateY(-50%)"
      },
      /* @__PURE__ */ React36.createElement(
        ForwardNavButton,
        {
          disabled: forwardArrowDisabled,
          onClick: ForwardNavButtonEvent
        }
      )
    ),
    showProgressDots && childrenLength >= 2 && /* @__PURE__ */ React36.createElement(
      ProgressDots,
      {
        currentDot: currentProgressIndex,
        length: childrenLength
      }
    )
  ));
};

// src/components/no-peek-carousel/no-peek-carousel.component.tsx
import {
  Box as Box19,
  HeadingText as HeadingText3,
  ParagraphText as ParagraphText2,
  StackLayout as StackLayout2,
  useTextDirectionality as useTextDirectionality2
} from "@leagueplatform/genesis-core";
import * as React39 from "react";
import { easing as easing2, tween as tween2 } from "popmotion";
import {
  SWIPE_DIRECTION as SWIPE_DIRECTION2,
  SWIPE_ORIENTATION as SWIPE_ORIENTATION2,
  useSwipeGestures as useSwipeGestures2
} from "@leagueplatform/web-common";
import { uniqueId } from "lodash";

// src/components/no-peek-carousel/no-peek-carousel-nav-button.component.tsx
import React37 from "react";
import { Button as Button5 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl12 } from "@leagueplatform/locales";
import { useStaticAsset } from "@leagueplatform/asset-config";
var NavButton2 = ({
  disabled,
  onClick,
  label,
  icon
}) => /* @__PURE__ */ React37.createElement(
  Button5,
  {
    css: {
      borderRadius: "$circle",
      justifyContent: "center",
      transition: "visibility 300ms, opacity 300ms",
      "&:disabled": {
        backgroundColor: "unset",
        // Fixes a bug when the button is disabled and the icon is focused and you end up getting a white icon on white background.
        color: "$onSurfaceTextSubdued"
      },
      "@mobile": {
        padding: "$quarter"
      }
    },
    textAlign: "center",
    disabled,
    onClick,
    "aria-label": label,
    quiet: true,
    size: "large",
    priority: "tertiary",
    hideLabel: true,
    icon
  },
  label
);
var NoPeekCarouselBackNavButton = ({
  disabled,
  onClick
}) => {
  const { formatMessage } = useIntl12();
  const backNavIcon = useStaticAsset(
    "WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_BACK" /* WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_BACK */
  );
  return /* @__PURE__ */ React37.createElement(
    NavButton2,
    {
      disabled,
      onClick,
      label: formatMessage({ id: "PREVIOUS" }),
      icon: backNavIcon
    }
  );
};
var NoPeekCarouselForwardNavButton = ({
  disabled,
  onClick
}) => {
  const { formatMessage } = useIntl12();
  const forwardNavIcon = useStaticAsset(
    "WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_FORWARD" /* WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_FORWARD */
  );
  return /* @__PURE__ */ React37.createElement(
    NavButton2,
    {
      disabled,
      onClick,
      label: formatMessage({ id: "NEXT" }),
      icon: forwardNavIcon
    }
  );
};

// src/components/no-peek-carousel/no-peek-carousel-progress-dots.component.tsx
import React38 from "react";
import { Box as Box18 } from "@leagueplatform/genesis-core";
import { useIntl as useIntl13 } from "@leagueplatform/locales";
var ProgressDot2 = ({
  isActive,
  label
}) => /* @__PURE__ */ React38.createElement(
  Box18,
  __spreadValues({
    as: "li",
    css: {
      display: "flex",
      height: "$threeQuarters",
      width: "$threeQuarters",
      cursor: "default",
      backgroundColor: isActive ? "$interactiveActionPrimary" : "$interactiveActionDisabled",
      borderRadius: "$circle"
    },
    "data-testid": "progress-dot"
  }, isActive && { "aria-current": "step", "aria-label": label })
);
var ProgressDots2 = ({ length, currentDot }) => {
  const { formatMessage } = useIntl13();
  const progressDots = new Array(length).fill(true);
  return /* @__PURE__ */ React38.createElement(
    Box18,
    {
      css: {
        display: "flex",
        flexDirection: "row",
        justify: "center",
        align: "center",
        width: "100%",
        gap: "$half",
        "@mobile": { flexWrap: "wrap" },
        justifyContent: "center"
      },
      as: "ul"
    },
    progressDots.map((active, index) => {
      const key = `progress-dot-${index}-${active}`;
      const isActive = currentDot === index;
      return /* @__PURE__ */ React38.createElement(
        ProgressDot2,
        {
          isActive,
          key,
          label: formatMessage(
            { id: "SLIDE_OF_TOTAL" },
            { key: index + 1, total: length }
          )
        }
      );
    })
  );
};

// src/components/no-peek-carousel/util/no-peek-carousel.utils.ts
import { useTheme } from "@leagueplatform/genesis-core";
var slicePx = (value) => Number(value.slice(0, -2));
var useGenesisSpaceTokenInPx = (spaceBetweenCards) => {
  const { space } = useTheme();
  const token = space[spaceBetweenCards.slice(1)];
  if (token) {
    const tokenValue = token.value;
    return slicePx(tokenValue);
  }
  return 16;
};
function getPositionRelativeToParent(element) {
  const parent = element.parentElement;
  const parentRect = parent == null ? void 0 : parent.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();
  if (parentRect) {
    return {
      top: elementRect.top - parentRect.top,
      left: elementRect.left - parentRect.left,
      bottom: elementRect.bottom - parentRect.top,
      right: elementRect.right - parentRect.left
    };
  }
  return {
    top: elementRect.top,
    left: elementRect.left,
    bottom: elementRect.bottom,
    right: elementRect.right
  };
}
var resizeObserverDebounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

// src/components/no-peek-carousel/no-peek-carousel.component.tsx
var COMPLEX_WIDGET_CARDS_WIDTH = "275px";
var COMPLEX_WIDGET_CARDS_WIDTH_MOBILE = "200px";
var CAROUSEL_SCROLL_TIME = 505;
var NoPeekCarouselGridWrapper = ({
  as = "ul",
  itemsPerSlide,
  gridChildMinWidth,
  gridColumnCount,
  gridGap: gap,
  carouselWrapperRef,
  children
}) => {
  const gridWrapperChildrenCount = React39.Children.count(children);
  const gapCount = itemsPerSlide - 1;
  const totalGapWidth = `${gapCount} * ${gap}px`;
  const maxGridItemWidth = `calc((100% - ${totalGapWidth}) / ${itemsPerSlide})`;
  const gridTemplateColumnCount = gridWrapperChildrenCount > gridColumnCount ? gridWrapperChildrenCount : itemsPerSlide;
  const gridColumnStyles = itemsPerSlide === 1 ? {
    gridAutoColumns: `minmax(max(${COMPLEX_WIDGET_CARDS_WIDTH_MOBILE}, calc(100% - var(--GDS-space-oneAndHalf))), 1fr)`
  } : {
    gridTemplateColumns: `repeat(${gridTemplateColumnCount}, minmax(max(${gridChildMinWidth}px, ${maxGridItemWidth}), 1fr))`
  };
  return /* @__PURE__ */ React39.createElement(
    Box19,
    {
      as,
      css: __spreadProps(__spreadValues({
        display: "grid"
      }, gridColumnStyles), {
        gridAutoFlow: "column",
        height: "100%",
        gap,
        overflow: "hidden",
        width: "100%",
        "@mobile": {
          gap: "$threeQuarters"
        }
      }),
      ref: carouselWrapperRef,
      "aria-live": "polite"
    },
    children
  );
};
var NoPeekCarousel = ({
  children,
  gridColumnCount = 3,
  itemMinWidth = slicePx(COMPLEX_WIDGET_CARDS_WIDTH),
  name,
  heading,
  description,
  linkOnClick,
  linkAriaLabel,
  headingLabelledBy,
  spaceBetweenCards = "$one",
  linkCta,
  linkUrl,
  BackNavButtonAnalyticsFn = () => null,
  ForwardNavButtonAnalyticsFn = () => null,
  showProgressDots = false
}) => {
  const dir = useTextDirectionality2();
  const [itemsPerSlide, setItemsPerSlide] = React39.useState(gridColumnCount);
  const [forwardArrowDisabled, setForwardArrowDisabled] = React39.useState(true);
  const [backArrowDisabled, setBackArrowDisabled] = React39.useState(true);
  const [currentCarouselSlideIndex, setCurrentCarouselSlideIndex] = React39.useState(0);
  const carouselWrapperContainerRef = React39.useRef(null);
  const carouselItemsContainerRef = React39.useRef(null);
  const swipeDirection = useSwipeGestures2(
    carouselItemsContainerRef,
    SWIPE_ORIENTATION2.horizontal
  );
  const spaceBetweenCardsInPx = useGenesisSpaceTokenInPx(spaceBetweenCards);
  const childrenItems = React39.Children.toArray(children);
  const numOfSlidesInCarousel = Math.ceil(childrenItems.length / itemsPerSlide);
  const shouldShowProgressDots = showProgressDots && numOfSlidesInCarousel > 1;
  const getCurrentCarouselItemsContainerProperties = React39.useCallback(() => {
    const { current: currentCarouselItemsContainerRef } = carouselItemsContainerRef;
    if (currentCarouselItemsContainerRef) {
      const { childNodes } = currentCarouselItemsContainerRef;
      const carouselItemsContainerRegistry = {};
      childNodes.forEach((_, index) => {
        const carouselItem = childNodes[index];
        carouselItemsContainerRegistry[index] = carouselItem;
      });
      return {
        carouselItemsContainerRegistry,
        currentCarouselItemsContainerRef
      };
    }
    return null;
  }, []);
  const setCarouselItemVisibility = React39.useCallback(() => {
    const currentCarouselItemsContainerProperties = getCurrentCarouselItemsContainerProperties();
    if (currentCarouselItemsContainerProperties) {
      const { carouselItemsContainerRegistry } = currentCarouselItemsContainerProperties;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.removeAttribute("aria-hidden");
              entry.target.removeAttribute("inert");
            } else {
              entry.target.setAttribute("aria-hidden", "true");
              entry.target.setAttribute("inert", "");
            }
          });
        },
        {
          root: carouselItemsContainerRef.current,
          threshold: 0.2
          // Trigger even if only 1 pixel is visible.  Adjust as needed.  1 means fully visible.
        }
      );
      Object.keys(carouselItemsContainerRegistry).forEach((key) => {
        const carouselItem = carouselItemsContainerRegistry[Number(key)];
        observer.observe(carouselItem);
      });
    }
    return null;
  }, [getCurrentCarouselItemsContainerProperties]);
  const setCarouselNavigationButtonsState = React39.useCallback(
    (slideIndex, slideCount) => {
      setForwardArrowDisabled(slideIndex === slideCount - 1);
      setBackArrowDisabled(slideIndex === 0);
      if (slideIndex > slideCount - 1) {
        setCurrentCarouselSlideIndex(slideCount - 1);
      }
    },
    []
  );
  const scrollTo = React39.useCallback(
    (amt = 0, duration = 0, onScrollComplete = () => {
    }) => {
      const { current: currentCarouselRef } = carouselItemsContainerRef;
      const to = dir === "ltr" ? amt : -amt;
      if (currentCarouselRef) {
        const from = currentCarouselRef.scrollLeft;
        const scroll = tween2({
          from,
          to,
          duration,
          ease: easing2.easeOut
        });
        scroll.start({
          update: (left) => {
            currentCarouselRef.scrollLeft = left;
          },
          complete: () => {
            setCarouselItemVisibility();
            onScrollComplete();
          }
        });
      }
    },
    [dir, setCarouselItemVisibility]
  );
  const onResizeCarouselContainerEventHandler = React39.useCallback(() => {
    const currentCarouselItemsContainerProperties = getCurrentCarouselItemsContainerProperties();
    if (currentCarouselItemsContainerProperties) {
      const {
        carouselItemsContainerRegistry,
        currentCarouselItemsContainerRef: { offsetWidth, scrollLeft }
      } = currentCarouselItemsContainerProperties;
      const minItemsPerSlide = Math.floor(
        (offsetWidth + spaceBetweenCardsInPx) / (itemMinWidth + spaceBetweenCardsInPx)
      );
      const updatedItemsPerSlide = Math.max(
        1,
        Math.min(minItemsPerSlide, gridColumnCount)
      );
      if (updatedItemsPerSlide !== itemsPerSlide) {
        setItemsPerSlide(updatedItemsPerSlide);
      }
      const doesCurrentSlideIndexExist = currentCarouselSlideIndex < numOfSlidesInCarousel;
      const updatedCarouselSlideIndex = doesCurrentSlideIndexExist ? currentCarouselSlideIndex : 0;
      if (updatedCarouselSlideIndex !== currentCarouselSlideIndex) {
        setCurrentCarouselSlideIndex(updatedCarouselSlideIndex);
        setCarouselNavigationButtonsState(
          updatedCarouselSlideIndex,
          numOfSlidesInCarousel
        );
      } else {
        setCarouselNavigationButtonsState(
          currentCarouselSlideIndex,
          numOfSlidesInCarousel
        );
      }
      const updatedCardIndex = updatedItemsPerSlide * updatedCarouselSlideIndex;
      const updatedScrollPosition = getPositionRelativeToParent(
        carouselItemsContainerRegistry[updatedCardIndex]
      ).left;
      if (updatedScrollPosition !== 0) {
        scrollTo(updatedScrollPosition + scrollLeft, CAROUSEL_SCROLL_TIME);
      }
      setCarouselItemVisibility();
    }
  }, [
    getCurrentCarouselItemsContainerProperties,
    spaceBetweenCardsInPx,
    itemMinWidth,
    gridColumnCount,
    itemsPerSlide,
    currentCarouselSlideIndex,
    numOfSlidesInCarousel,
    scrollTo,
    setCarouselNavigationButtonsState,
    setCarouselItemVisibility
  ]);
  React39.useEffect(() => {
    const { current } = carouselWrapperContainerRef;
    if (current) {
      const debounceCallback = resizeObserverDebounce(
        onResizeCarouselContainerEventHandler,
        250
      );
      const carouselResizeObserver = new ResizeObserver(() => {
        debounceCallback();
      });
      carouselResizeObserver.observe(current);
      return () => {
        carouselResizeObserver.disconnect();
      };
    }
    onResizeCarouselContainerEventHandler();
    return () => null;
  }, [onResizeCarouselContainerEventHandler]);
  const handleNavButtonEvent = React39.useCallback(
    (type) => {
      const carouselItemsContainerProperties = getCurrentCarouselItemsContainerProperties();
      if (carouselItemsContainerProperties) {
        const {
          currentCarouselItemsContainerRef: { scrollLeft },
          carouselItemsContainerRegistry
        } = carouselItemsContainerProperties;
        switch (type) {
          case "FORWARD" /* forward */:
            if (currentCarouselSlideIndex < numOfSlidesInCarousel - 1) {
              const nextCardIndex = itemsPerSlide * (currentCarouselSlideIndex + 1);
              const scrollPosition = getPositionRelativeToParent(
                carouselItemsContainerRegistry[nextCardIndex]
              ).left + scrollLeft;
              scrollTo(
                scrollPosition,
                CAROUSEL_SCROLL_TIME,
                setCurrentCarouselSlideIndex(currentCarouselSlideIndex + 1)
              );
            }
            break;
          case "BACK" /* back */:
            if (currentCarouselSlideIndex > 0) {
              const prevCardIndex = itemsPerSlide * (currentCarouselSlideIndex - 1);
              const scrollPosition = getPositionRelativeToParent(
                carouselItemsContainerRegistry[prevCardIndex]
              ).left + scrollLeft;
              scrollTo(
                scrollPosition,
                CAROUSEL_SCROLL_TIME,
                setCurrentCarouselSlideIndex(currentCarouselSlideIndex - 1)
              );
            }
            break;
          default:
            break;
        }
      }
    },
    [
      getCurrentCarouselItemsContainerProperties,
      currentCarouselSlideIndex,
      numOfSlidesInCarousel,
      itemsPerSlide,
      scrollTo
    ]
  );
  const BackNavButtonEvent = React39.useCallback(() => {
    handleNavButtonEvent("BACK" /* back */);
    BackNavButtonAnalyticsFn();
  }, [BackNavButtonAnalyticsFn, handleNavButtonEvent]);
  const ForwardNavButtonEvent = React39.useCallback(() => {
    handleNavButtonEvent("FORWARD" /* forward */);
    ForwardNavButtonAnalyticsFn();
  }, [ForwardNavButtonAnalyticsFn, handleNavButtonEvent]);
  React39.useEffect(() => {
    if (swipeDirection) {
      switch (swipeDirection) {
        case SWIPE_DIRECTION2.right:
          if (dir === "ltr") {
            ForwardNavButtonEvent();
          } else {
            BackNavButtonEvent();
          }
          break;
        case SWIPE_DIRECTION2.left:
          if (dir === "ltr") {
            BackNavButtonEvent();
          } else {
            ForwardNavButtonEvent();
          }
          break;
        default:
          break;
      }
    }
  }, [swipeDirection, dir, BackNavButtonEvent, ForwardNavButtonEvent]);
  React39.useEffect(() => {
    scrollTo(0, 0);
  }, [scrollTo]);
  if (children === void 0) {
    console.warn(`No children found for carousel: ${name}`);
    return null;
  }
  if (!!linkUrl && linkCta === void 0 || !!linkCta && linkUrl === void 0) {
    if (linkCta === void 0) {
      console.warn(
        `Link CTA will not render. "linkUrl" prop provided, but "linkCta" prop missing for carousel: ${name}. Please provide both props.`
      );
    } else {
      console.warn(
        `Link CTA will not render. "linkCta" prop provided, but "linkUrl" prop missing for carousel: ${name}. Please provide both props.`
      );
    }
  }
  let Description = description;
  if (description && typeof description === "string") {
    Description = /* @__PURE__ */ React39.createElement(ParagraphText2, null, description);
  }
  const headingId = uniqueId("no-peek-carousel-");
  let Heading2 = heading;
  if (heading && typeof heading === "string") {
    Heading2 = /* @__PURE__ */ React39.createElement(HeadingText3, { level: "2", size: "xl", id: headingId }, heading);
  }
  return /* @__PURE__ */ React39.createElement(
    Box19,
    {
      "data-testid": "no-peek-carousel",
      "aria-labelledby": headingLabelledBy != null ? headingLabelledBy : headingId,
      as: "section",
      css: {
        width: "100%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: "$one"
      },
      ref: carouselWrapperContainerRef
    },
    /* @__PURE__ */ React39.createElement(StackLayout2, { spacing: "$quarter" }, /* @__PURE__ */ React39.createElement(
      StackLayout2,
      {
        orientation: "horizontal",
        horizontalAlignment: heading ? "spaceBetween" : "end",
        css: { width: "100%", alignItems: "center" }
      },
      Heading2,
      /* @__PURE__ */ React39.createElement(
        Box19,
        {
          css: {
            display: "flex",
            marginLeft: "$threeQuarters",
            alignItems: "center",
            gap: "$oneAndHalf",
            rowGap: "$threeQuarters"
          }
        },
        linkCta && linkUrl && /* @__PURE__ */ React39.createElement(
          CTALink,
          {
            onClick: linkOnClick,
            ariaLabel: linkAriaLabel,
            href: linkUrl
          },
          linkCta
        ),
        numOfSlidesInCarousel > 1 && /* @__PURE__ */ React39.createElement(
          Box19,
          {
            css: {
              display: "flex",
              gap: "$one",
              flexWrap: "nowrap",
              "@mobile": {
                gap: "$quarter"
              }
            }
          },
          /* @__PURE__ */ React39.createElement(
            NoPeekCarouselBackNavButton,
            {
              disabled: backArrowDisabled,
              onClick: BackNavButtonEvent
            }
          ),
          /* @__PURE__ */ React39.createElement(
            NoPeekCarouselForwardNavButton,
            {
              disabled: forwardArrowDisabled,
              onClick: ForwardNavButtonEvent
            }
          )
        )
      )
    ), /* @__PURE__ */ React39.createElement(ParagraphText2, null, Description)),
    /* @__PURE__ */ React39.createElement(
      Box19,
      {
        css: {
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          overflowX: "hidden",
          position: "relative",
          gap: "$one"
        }
      },
      /* @__PURE__ */ React39.createElement(
        NoPeekCarouselGridWrapper,
        {
          carouselWrapperRef: carouselItemsContainerRef,
          itemsPerSlide,
          gridChildMinWidth: itemMinWidth,
          gridColumnCount,
          gridGap: spaceBetweenCardsInPx
        },
        childrenItems.map((e, index) => /* @__PURE__ */ React39.createElement(
          Box19,
          {
            as: "li",
            css: {
              minWidth: COMPLEX_WIDGET_CARDS_WIDTH,
              "@mobile": {
                minWidth: COMPLEX_WIDGET_CARDS_WIDTH_MOBILE
              }
            },
            key: uniqueId("carousel-item-"),
            id: `carousel-item-${index}`
          },
          e
        ))
      )
    ),
    shouldShowProgressDots && /* @__PURE__ */ React39.createElement(
      ProgressDots2,
      {
        currentDot: currentCarouselSlideIndex,
        length: numOfSlidesInCarousel
      }
    )
  );
};

// src/components/card-banner/card-banner.component.tsx
import React41 from "react";
import { isAbsoluteUrl as isAbsoluteUrl2 } from "@leagueplatform/web-common";
import {
  css as css7,
  genesisStyled as genesisStyled11,
  Flex as Flex15
} from "@leagueplatform/genesis-commons";

// src/components/internal-or-external-link/internal-or-external-link.component.tsx
import React40, { forwardRef as forwardRef2 } from "react";
import { styled as styled4 } from "@leagueplatform/genesis-core";
import { LinkLegacy as Link3 } from "@leagueplatform/routing";
import { isAbsoluteUrl } from "@leagueplatform/web-common";
var StyledLink2 = styled4("a");
var InternalOrExternalLink = forwardRef2((_a, ref) => {
  var _b = _a, { href, children } = _b, linkProps = __objRest(_b, ["href", "children"]);
  const { isExternalUrl: isExternalUrl2 = isAbsoluteUrl(href) } = linkProps;
  const isNonRouteLink = href.includes("tel:") || href.includes("mailto:");
  if (isNonRouteLink) {
    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      /* @__PURE__ */ React40.createElement(StyledLink2, __spreadValues({ ref, href }, linkProps), children)
    );
  }
  return /* @__PURE__ */ React40.createElement(
    StyledLink2,
    __spreadValues({
      ref,
      as: isExternalUrl2 ? "a" : Link3,
      to: isExternalUrl2 ? void 0 : href,
      href: isExternalUrl2 ? href : void 0,
      target: isExternalUrl2 ? "_blank" : void 0,
      rel: isExternalUrl2 ? "noopener noreferrer" : void 0
    }, linkProps),
    children
  );
});

// src/components/card-banner/card-banner.component.tsx
var StaticWrapper = genesisStyled11(Flex15)(
  ({ backgroundColor, theme, styles }) => css7(__spreadValues({
    flex: 1,
    flexDirection: "column-reverse",
    backgroundColor: backgroundColor || "surface.card.primary",
    borderStyle: "solid",
    borderColor: "onSurface.border.subdued",
    borderWidth: "thin",
    borderRadius: "large",
    overflow: "hidden",
    [`@media screen and (min-width: ${theme.breakpoints.phone})`]: {
      minHeight: "200px",
      flexDirection: "row"
    }
  }, styles))
);
var LinkableWrapper = genesisStyled11(StaticWrapper)(
  ({ backgroundColor }) => css7({
    textDecoration: "none",
    "&::before": {
      borderRadius: "large"
    },
    "&:hover": {
      backgroundColor: !backgroundColor && "interactive.background.hovered",
      borderColor: "interactive.border.hovered"
    },
    "&:active": {
      backgroundColor: !backgroundColor && "interactive.background.pressed"
    }
  })
);
var StyledChildren = genesisStyled11(Flex15)(
  css7({
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
    padding: "oneAndHalf"
  })
);
var StyledImageContainer = genesisStyled11(Flex15)(
  ({ styles, theme, src }) => css7(__spreadValues({
    [`@media screen and (min-width: ${theme.breakpoints.phone})`]: {
      maxWidth: "280px",
      flexBasis: "100%",
      flexShrink: "0",
      borderInlineStartStyle: "solid",
      borderColor: "onSurface.border.subdued",
      borderWidth: "thin"
    },
    width: "100%",
    minHeight: "200px",
    background: `url(${src}) center no-repeat`,
    backgroundSize: "cover"
  }, styles))
);
var CardBanner = ({
  url,
  image,
  children,
  backgroundColor,
  styles,
  onClick
}) => {
  if (url) {
    const isExternalUrl2 = isAbsoluteUrl2(url);
    return /* @__PURE__ */ React41.createElement(
      LinkableWrapper,
      {
        href: url,
        onClick,
        isExternalUrl: isExternalUrl2,
        as: InternalOrExternalLink,
        backgroundColor,
        styles: styles == null ? void 0 : styles.wrapper
      },
      /* @__PURE__ */ React41.createElement(StyledChildren, null, children, isExternalUrl2 && /* @__PURE__ */ React41.createElement(OpensInANewTabMessage, null)),
      /* @__PURE__ */ React41.createElement(StyledImageContainer, { styles: styles == null ? void 0 : styles.imageContainer, src: image })
    );
  }
  return /* @__PURE__ */ React41.createElement(StaticWrapper, { backgroundColor, styles: styles == null ? void 0 : styles.wrapper }, /* @__PURE__ */ React41.createElement(StyledChildren, null, children), /* @__PURE__ */ React41.createElement(StyledImageContainer, { styles: styles == null ? void 0 : styles.imageContainer, src: image }));
};

// src/components/stack-layout/stack-layout.component.tsx
import React42 from "react";
import {
  Box as Box20,
  styled as styled5
} from "@leagueplatform/genesis-core";
var StackLayoutBox = styled5(Box20, {
  "&& > * + *": {
    marginTop: "$$space"
  }
});
var StackLayout3 = ({
  space = "$one",
  css: css20,
  children,
  as: asElement
}) => /* @__PURE__ */ React42.createElement(StackLayoutBox, { as: asElement, css: __spreadProps(__spreadValues({}, css20), { $$space: `$space${space}` }) }, children);

// src/components/app-store-icons/appstore-icons.tsx
import React43 from "react";
import { Link as Link4, Image as Image6 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl14 } from "@leagueplatform/locales";
import appStoreEN from "./assets/download-appstore-badge-en.svg";
import playStoreEN from "./assets/download-google-play-badge-en.svg";
import appStoreFR from "./assets/download-appstore-badge-fr.svg";
import playStoreFR from "./assets/download-google-play-badge-fr.svg";
import { EVENT_NAME, trackAnalyticsEvent } from "@leagueplatform/analytics";
var LEAGUE_APP_GOOGLE_STORE_URL = "https://play.google.com/store/apps/details?id=life.league";
var LEAGUE_APP_APPLE_STORE_URL = "https://apps.apple.com/ca/app/league-health-wellness-professionals/id952832544";
var APP_ICON_SRC = {
  APPLE: {
    fr: appStoreFR,
    en: appStoreEN
  },
  GOOGLE: {
    fr: playStoreFR,
    en: playStoreEN
  }
};
function getAppIcon(type, locale) {
  const appIcon = APP_ICON_SRC[type];
  if (locale.includes("fr")) {
    return appIcon.fr;
  }
  if (locale.includes("en")) {
    return appIcon.en;
  }
  return "";
}
var AppleAppIcon = ({
  imageSize,
  href = LEAGUE_APP_APPLE_STORE_URL
}) => {
  const { formatMessage, locale } = useIntl14();
  return /* @__PURE__ */ React43.createElement(
    Link4,
    {
      href,
      onClick: () => {
        trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
          screen_name: "Member Download App",
          detail: "Download Apple Store App",
          sub_detail: "Download on the App Store"
        });
      }
    },
    /* @__PURE__ */ React43.createElement(
      Image6,
      {
        alt: formatMessage({ id: "DOWNLOAD_APP_STORE" }),
        src: getAppIcon("APPLE", locale),
        height: imageSize,
        width: "auto",
        display: "block"
      }
    )
  );
};
var GoogleAppIcon = ({
  imageSize,
  href = LEAGUE_APP_GOOGLE_STORE_URL
}) => {
  const { formatMessage, locale } = useIntl14();
  return /* @__PURE__ */ React43.createElement(
    Link4,
    {
      href,
      onClick: () => {
        trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
          screen_name: "Member Download App",
          detail: "Download Google Play App",
          sub_detail: "Get it on Google Play"
        });
      }
    },
    /* @__PURE__ */ React43.createElement(
      Image6,
      {
        alt: formatMessage({ id: "DOWNLOAD_PLAY_STORE" }),
        src: getAppIcon("GOOGLE", locale),
        height: imageSize,
        width: "auto",
        display: "block"
      }
    )
  );
};

// src/components/sidebar/sidebar.tsx
import React44 from "react";
import { Flex as Flex16, css as css8, genesisStyled as genesisStyled12 } from "@leagueplatform/genesis-commons";
var SIDEBAR_MIN_WIDTH = "282px";
var gapValue = { gap: "oneAndHalf" };
var addSidebarSpacing = css8(__spreadProps(__spreadValues({}, gapValue), {
  flexDirection: "column"
}));
var SidebarItemContainer = genesisStyled12(Flex16)(css8(__spreadValues({}, gapValue)));
function Sidebar({ children, className }) {
  return /* @__PURE__ */ React44.createElement(
    SidebarItemContainer,
    {
      className,
      flexDirection: { _: "column", phone: "row", laptop: "column" },
      justifyContent: "space-between",
      alignItems: { phone: "center", laptop: "initial" },
      minWidth: { laptop: SIDEBAR_MIN_WIDTH },
      maxWidth: { laptop: "282px" },
      width: "100%",
      padding: { _: "oneAndHalf", laptop: "none" },
      borderStyle: { _: "solid", laptop: "none" },
      borderWidth: "thin",
      borderColor: "onSurface.border.subdued",
      bottom: { _: "0", laptop: "initial" },
      insetInlineStart: { _: "0", laptop: "initial" },
      position: { _: "fixed", laptop: "initial" },
      backgroundColor: { _: "surface.background.primary", laptop: "initial" },
      marginY: { laptop: "oneAndHalf" },
      zIndex: "1"
    },
    children
  );
}

// src/components/sidebar/sidebar-card.tsx
import * as React45 from "react";
import { Box as Box21 } from "@leagueplatform/genesis-commons";
function SidebarCard(props) {
  return /* @__PURE__ */ React45.createElement(
    Box21,
    __spreadValues({
      borderStyle: { laptop: "solid" },
      borderWidth: "thin",
      borderColor: "interactive.border.disabled",
      borderRadius: "medium",
      backgroundColor: "surface.background.primary",
      boxShadow: { laptop: "card" },
      padding: { laptop: "oneAndHalf" }
    }, props)
  );
}

// src/components/feedback-card/feedback-card.component.tsx
import React47 from "react";
import {
  Flex as Flex18,
  HeadingFour,
  SubtitleOne as SubtitleOne2,
  Box as Box22
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl15 } from "@leagueplatform/locales";
import range from "lodash/range";

// src/components/feedback-card/components/feedback-input.component.tsx
import {
  genesisStyled as genesisStyled13,
  Flex as Flex17,
  css as css9,
  BodyOne as BodyOne5
} from "@leagueplatform/genesis-commons";
import * as React46 from "react";
var CIRCLE_SIZE_LARGE = "56px";
var CIRCLE_SIZE_SMALL = "34px";
var CircleLabel = genesisStyled13(Flex17)(
  ({ isSmall, theme }) => css9({
    textDecoration: "none",
    cursor: "pointer",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    backgroundColor: "transparent",
    borderWidth: "thin",
    borderStyle: "solid",
    borderColor: "decorative.brand.primary.default",
    transition: "all 250ms ease-in-out",
    borderRadius: "circle",
    fontWeight: "bold",
    color: "decorative.brand.primary.default",
    height: isSmall ? CIRCLE_SIZE_SMALL : CIRCLE_SIZE_LARGE,
    width: isSmall ? CIRCLE_SIZE_SMALL : CIRCLE_SIZE_LARGE,
    fontSize: isSmall ? "subtitle1" : "heading2",
    "&:hover": {
      backgroundColor: "decorative.brand.primary.default",
      color: "onSurface.text.reversed"
    },
    "&:focus": {
      backgroundColor: "decorative.brand.primary.default",
      color: "onSurface.text.reversed",
      outlineWidth: "thick",
      outlineColor: "secondary.background.hovered",
      outlineStyle: "solid"
    },
    [`@media screen and (max-width: ${theme.breakpoints.tablet})`]: {
      height: CIRCLE_SIZE_SMALL,
      width: CIRCLE_SIZE_SMALL,
      fontSize: "subtitle1"
    }
  })
);
var ExpandedLabel = genesisStyled13(BodyOne5)(
  ({ isSmall, theme }) => css9({
    color: "inherit",
    whiteSpace: "nowrap",
    fontSize: isSmall ? "subtitle2" : "inherit",
    position: ["absolute", "initial"],
    top: `calc(100% - ${theme.space.half}px)`,
    insetInlineStart: "50%",
    transform: ["translateX(-50%)", "none"],
    [`@media screen and (max-width: ${theme.breakpoints.tablet})`]: {
      fontSize: "subtitle1"
    }
  })
);
var FeedbackInput = ({
  label,
  ariaLabel,
  value,
  expandedLabel,
  isSmall = true,
  href,
  isFirst,
  onClick
}) => {
  const EXPANDED_LABEL_ID = `feedback-expanded-label-${isFirst ? "first" : "last"}`;
  return /* @__PURE__ */ React46.createElement(
    Flex17,
    {
      display: ["inline-block", "flex"],
      alignItems: "center",
      gap: ["none", "one"],
      justifyContent: "center",
      position: "relative",
      paddingBottom: ["half", "none", "none"]
    },
    isFirst && expandedLabel && /* @__PURE__ */ React46.createElement(ExpandedLabel, { id: EXPANDED_LABEL_ID, isSmall }, expandedLabel),
    /* @__PURE__ */ React46.createElement(
      CircleLabel,
      {
        as: "a",
        href,
        isSmall,
        "data-testid": "feedback-rating-item",
        "aria-label": ariaLabel,
        "aria-describedby": expandedLabel ? EXPANDED_LABEL_ID : void 0,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: () => {
          if (onClick) {
            onClick(value);
          }
        }
      },
      label
    ),
    !isFirst && expandedLabel && /* @__PURE__ */ React46.createElement(ExpandedLabel, { id: EXPANDED_LABEL_ID, isSmall }, expandedLabel)
  );
};

// src/components/feedback-card/feedback-card.component.tsx
var FeedbackCard = ({
  backgroundColor = "surface.background.secondary",
  title,
  subtitle,
  min = 1,
  max = 5,
  size = "small",
  minMaxTextColor = "onSurface.text.subdued",
  onClick,
  feedbackUrl = "#"
}) => {
  const { formatMessage } = useIntl15();
  const isSmall = size === "small";
  const hasSubtitle = !!subtitle;
  return /* @__PURE__ */ React47.createElement(
    Flex18,
    {
      flexDirection: "column",
      borderRadius: "medium",
      backgroundColor,
      alignItems: "center",
      padding: "two"
    },
    /* @__PURE__ */ React47.createElement(StackLayout3, { space: "$half", css: { width: "100%", textAlign: "center" } }, /* @__PURE__ */ React47.createElement(Box22, null, /* @__PURE__ */ React47.createElement(HeadingFour, { as: "h2" }, title)), /* @__PURE__ */ React47.createElement(
      Box22,
      {
        as: "fieldset",
        flexDirection: "column",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        textAlign: "center"
      },
      hasSubtitle && /* @__PURE__ */ React47.createElement(SubtitleOne2, { as: "legend" }, subtitle),
      /* @__PURE__ */ React47.createElement(
        Flex18,
        {
          alignItems: "center",
          maxWidth: isSmall ? "450px" : "85%",
          width: 1,
          color: minMaxTextColor,
          gap: "half",
          justifyContent: "space-around",
          marginTop: "two"
        },
        range(min, max + 1).map((number, index) => {
          let expandedLabel;
          if (index === 0) {
            expandedLabel = formatMessage({
              id: "FEEDBACK_MIN_SCALE"
            });
          } else if (number === max) {
            expandedLabel = formatMessage({
              id: "FEEDBACK_MAX_SCALE"
            });
          }
          return /* @__PURE__ */ React47.createElement(
            FeedbackInput,
            {
              key: `feedback-input-item-${number}`,
              value: number,
              ariaLabel: formatMessage(
                { id: "FEEDBACK_LINK_LABEL" },
                { value: number, maximum: max }
              ),
              label: `${number}`,
              href: `${feedbackUrl}${number}`,
              onClick,
              isFirst: index === 0,
              isSmall,
              expandedLabel
            }
          );
        })
      )
    ))
  );
};

// src/components/page-not-found/page-not-found.component.tsx
import * as React49 from "react";
import {
  BodyOne as BodyOne6,
  Box as Box23,
  Flex as Flex19,
  HeadingTwo as HeadingTwo2,
  PrimaryButton as PrimaryButton2
} from "@leagueplatform/genesis-commons";
import { useIntl as useIntl16 } from "@leagueplatform/locales";

// src/components/genesis-router-link/genesis-router-link.jsx
import React48 from "react";
import { LinkLegacy as Link5 } from "@leagueplatform/routing";
import { TextAction as TextAction3 } from "@leagueplatform/genesis-core";
var GenesisRouterLink = (props) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  /* @__PURE__ */ React48.createElement(TextAction3, __spreadValues({ as: Link5 }, props))
);

// src/components/page-not-found/page-not-found.component.tsx
function PageNotFound({
  redirectLink = "/",
  buttonText
}) {
  const { formatMessage } = useIntl16();
  return /* @__PURE__ */ React49.createElement(
    Flex19,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "surface.background.secondary",
      textAlign: "center",
      position: "absolute",
      top: 0,
      bottom: 0,
      insetInlineStart: 0,
      insetInlineEnd: 0
    },
    /* @__PURE__ */ React49.createElement(
      Box23,
      {
        borderRadius: "small",
        paddingY: "two",
        paddingX: "four",
        width: "45rem",
        backgroundColor: "surface.background.primary",
        boxShadow: "card"
      },
      /* @__PURE__ */ React49.createElement(StackLayout3, { space: "$two" }, /* @__PURE__ */ React49.createElement(HeadingTwo2, null, formatMessage({ id: "PAGE_NOT_FOUND_HEADER" })), /* @__PURE__ */ React49.createElement(Box23, null, /* @__PURE__ */ React49.createElement(BodyOne6, null, formatMessage({ id: "PAGE_NOT_FOUND_CONTENT" })), /* @__PURE__ */ React49.createElement(BodyOne6, null, formatMessage({ id: "PAGE_NOT_FOUND_CONTENT_SECONDARY" }))), /* @__PURE__ */ React49.createElement(PrimaryButton2, { as: GenesisRouterLink, to: redirectLink }, buttonText != null ? buttonText : formatMessage({ id: "PAGE_NOT_FOUND_BUTTON" })))
    )
  );
}

// src/components/avatar/avatar.component.tsx
import React50 from "react";
import {
  BodyOne as BodyOne7,
  Flex as Flex20,
  genesisStyled as genesisStyled14,
  CoverImage as CoverImage2
} from "@leagueplatform/genesis-commons";
var UserInitials = genesisStyled14(BodyOne7)`
  text-transform: uppercase;
`;
var Avatar = (_a) => {
  var _b = _a, {
    imageSrc,
    userInitials,
    altText = "",
    fontSize = "body1"
  } = _b, props = __objRest(_b, [
    "imageSrc",
    "userInitials",
    "altText",
    "fontSize"
  ]);
  return /* @__PURE__ */ React50.createElement(
    Flex20,
    __spreadValues({
      overflow: "hidden",
      borderRadius: "circle",
      width: "four",
      height: "four",
      alignItems: "center",
      justifyContent: "center",
      borderColor: "interactive.border.disabled",
      borderWidth: imageSrc ? "none" : "thin",
      borderStyle: "solid",
      backgroundColor: "surface.card.primary",
      className: "avatar-wrapper"
    }, props),
    imageSrc ? /* @__PURE__ */ React50.createElement(
      CoverImage2,
      {
        src: imageSrc,
        alt: altText,
        size: "100%",
        role: "presentation"
      }
    ) : userInitials && /* @__PURE__ */ React50.createElement(UserInitials, { "aria-hidden": "true", fontSize }, userInitials)
  );
};

// src/components/app-nav-bar/app-nav.component.tsx
import React54 from "react";

// src/components/app-nav-bar/app-nav.header.component.tsx
import React51 from "react";
import {
  Box as Box24,
  StackLayout as StackLayout4,
  TextAction as TextAction4,
  styled as styled6,
  queryHelpers as queryHelpers2,
  useMediaQuery as useMediaQuery2
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl17 } from "@leagueplatform/locales";
var APP_NAV_DEFAULT_HEIGHT = 8 * 7;
var SkipContentBox = styled6(Box24, {
  position: "absolute",
  zIndex: "$dropdown",
  "&:focus-within": {
    // include the focus outline when positioning
    insetInlineStart: "$quarter",
    top: "$quarter"
  }
});
var AppBarHeader = ({
  children,
  navHeight = APP_NAV_DEFAULT_HEIGHT,
  enableSkipToContent = true,
  headerCSS
}) => {
  const { formatMessage } = useIntl17();
  const isMobile = useMediaQuery2(queryHelpers2.down("mobileLandscape"));
  return /* @__PURE__ */ React51.createElement(
    StackLayout4,
    {
      id: "app_nav",
      as: "header",
      role: "banner",
      horizontalAlignment: "spaceBetween",
      "data-testid": "react_member_app_nav",
      orientation: "horizontal",
      verticalAlignment: "stretch",
      css: __spreadValues({
        color: "$onSurfaceTextSubdued",
        maxHeight: navHeight,
        minHeight: navHeight,
        paddingInlineEnd: "$quarter",
        paddingInlineStart: "$quarter",
        backgroundColor: "$surfaceBackgroundPrimary",
        boxShadow: "$dropdown",
        position: "sticky",
        top: 0,
        zIndex: "$sticky",
        "@laptop": {
          paddingInlineEnd: "$one",
          paddingInlineStart: "$one"
        },
        "@desktop": {
          paddingInlineEnd: "$three",
          paddingInlineStart: "$three"
        }
      }, headerCSS)
    },
    enableSkipToContent && /* @__PURE__ */ React51.createElement(
      SkipContentBox,
      {
        css: {
          top: isMobile ? "-180%" : "-300%"
        }
      },
      /* @__PURE__ */ React51.createElement(
        TextAction4,
        {
          css: {
            padding: "$half",
            borderColor: "$onSurfaceBorderSubdued",
            borderWidth: "thin",
            backgroundColor: "$surfaceBackgroundPrimary",
            "&&:focus": {
              outlineOffset: "0"
            }
          },
          href: "#main-content"
        },
        formatMessage({ id: "SKIP_TO_CONTENT_MESSAGE" })
      )
    ),
    children
  );
};

// src/components/app-nav-bar/app-nav.nav.component.tsx
import React52 from "react";
import { StackLayout as StackLayout5 } from "@leagueplatform/genesis-core";
var AppBarNav = ({ children }) => /* @__PURE__ */ React52.createElement(StackLayout5, { as: "nav", orientation: "horizontal", verticalAlignment: "stretch" }, children);

// src/components/app-nav-bar/app-nav.nav-list.component.tsx
import React53 from "react";
import { useIntl as useIntl18 } from "@leagueplatform/locales";
import { StackLayout as StackLayout6 } from "@leagueplatform/genesis-core";
var AppBarNavList = ({ children }) => {
  const { formatMessage } = useIntl18();
  return /* @__PURE__ */ React53.createElement(
    StackLayout6,
    {
      as: "ul",
      orientation: "horizontal",
      "aria-label": formatMessage({ id: "MAIN_NAVIGATION_LIST_LABEL" }),
      horizontalAlignment: "spaceBetween",
      css: { alignItems: "stretch" }
    },
    children
  );
};

// src/components/app-nav-bar/app-nav.component.tsx
var AppBarComponent = ({
  children,
  navHeight,
  enableSkipToContent,
  headerCSS
}) => /* @__PURE__ */ React54.createElement(
  AppBarHeader,
  {
    navHeight,
    enableSkipToContent,
    headerCSS
  },
  /* @__PURE__ */ React54.createElement(AppBarNav, null, /* @__PURE__ */ React54.createElement(AppBarNavList, null, children))
);

// src/components/app-nav-bar/app-nav.nav-items.component.tsx
import React55 from "react";
import { NavLink } from "@leagueplatform/routing";
import {
  Box as Box25,
  css as css10,
  Flex as Flex21,
  genesisStyled as genesisStyled15,
  Link as Link6
} from "@leagueplatform/genesis-commons";
var StyledLink3 = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React55.createElement(
    Link6,
    __spreadValues({
      display: "flex",
      position: "relative",
      alignSelf: "stretch",
      alignItems: "center",
      color: "onSurface.text.subdued",
      fontSize: "subtitle2",
      textAlign: "center",
      paddingX: { _: (props == null ? void 0 : props.isMobile) ? 0 : "quarter", laptop: "half" },
      textDecoration: "none !important",
      hoverStyle: { color: "onSurface.text.primary" }
    }, props),
    /* @__PURE__ */ React55.createElement(Box25, { as: "span" }, children)
  );
};
var StyledNavLink = genesisStyled15((props) => /* @__PURE__ */ React55.createElement(StyledLink3, __spreadValues({ as: NavLink }, props)))(
  (props) => {
    var _a;
    return css10({
      '&[aria-current="page"]': {
        color: !((_a = props.hoverStyle) == null ? void 0 : _a.color) ? "onSurface.text.primary" : props.hoverStyle.color
      },
      '&[aria-current="page"]:after': {
        content: '""',
        display: "block",
        position: "absolute",
        bottom: -1,
        insetInlineStart: 0,
        backgroundColor: (props == null ? void 0 : props.isMobile) ? "transparent" : (props == null ? void 0 : props.decorativeBarColor) || "interactive.action.primary",
        height: "quarter",
        borderRadius: "large",
        width: "100%"
      }
    });
  }
);
var AppBarItem = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React55.createElement(Flex21, __spreadValues({ as: "li", flexGrow: 1, alignSelf: "stretch" }, props), children);
};
var AppBarLink = (_a) => {
  var _b = _a, {
    children,
    listItemProps
  } = _b, props = __objRest(_b, [
    "children",
    "listItemProps"
  ]);
  return /* @__PURE__ */ React55.createElement(AppBarItem, __spreadValues({}, listItemProps), /* @__PURE__ */ React55.createElement(StyledLink3, __spreadValues({}, props), children));
};
var AppBarNavLink = (_a) => {
  var _b = _a, {
    children,
    listItemProps
  } = _b, props = __objRest(_b, [
    "children",
    "listItemProps"
  ]);
  return /* @__PURE__ */ React55.createElement(AppBarItem, __spreadValues({}, listItemProps), /* @__PURE__ */ React55.createElement(StyledNavLink, __spreadValues({}, props), children));
};

// src/components/highlight-banner/highlight-banner.component.jsx
import React56 from "react";
import PropTypes8 from "prop-types";
import {
  Flex as Flex22,
  Box as Box26,
  SubtitleTwo as SubtitleTwo2,
  Overline as Overline3,
  Image as Image7
} from "@leagueplatform/genesis-commons";
var HighlightBanner = ({
  title,
  icon,
  backgroundColor,
  color,
  marginBottom,
  children
}) => /* @__PURE__ */ React56.createElement(
  Box26,
  {
    backgroundColor,
    borderRadius: "medium",
    marginBottom,
    padding: "one"
  },
  /* @__PURE__ */ React56.createElement(Flex22, { alignItems: "center" }, icon && /* @__PURE__ */ React56.createElement(Image7, { src: icon, alt: "", width: "oneAndHalf", marginInlineEnd: "half" }), /* @__PURE__ */ React56.createElement(Overline3, { as: "p", color }, title)),
  /* @__PURE__ */ React56.createElement(SubtitleTwo2, { as: "p", fontWeight: "regular", marginTop: "half", color }, children)
);
HighlightBanner.propTypes = {
  title: PropTypes8.string.isRequired,
  icon: PropTypes8.string,
  backgroundColor: PropTypes8.string,
  color: PropTypes8.string,
  marginBottom: PropTypes8.string,
  children: PropTypes8.node.isRequired
};
HighlightBanner.defaultProps = {
  icon: null,
  backgroundColor: "highlight.background.subdued",
  color: "onSurface.text.primary",
  marginBottom: "twoAndHalf"
};

// src/components/skeleton-box/skeleton-box.component.tsx
import React57 from "react";
import {
  Box as Box27,
  Flex as Flex23,
  genesisStyled as genesisStyled16
} from "@leagueplatform/genesis-commons";
var SkeletonBox = genesisStyled16(
  Box27
)`
    width: ${(props) => props.width || "100%"};
    background-color: ${(props) => props.backgroundColor || props.theme.colors.surface.background.secondary};
    height: ${(props) => props.height};
    border-radius: ${(props) => props.borderRadius || "6px"};
    margin-bottom: ${(props) => props.marginBottom || "0px"};
    margin-top: ${(props) => props.marginTop || "0px"};
    padding-top: ${(props) => props.paddingTop || "0px"};
    padding-bottom: ${(props) => props.paddingBottom || "0px"};
    z-index: 0;
    position: relative;
    overflow: hidden;
    &:after {
      content: '';
      top: 0;
      transform: translateX(100%);
      width: 100%;
      height: ${(props) => props.height};
      position: absolute;
      z-index: 1;
      animation: slide 2s infinite;
      background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.4) 50%,
          rgba(128, 186, 232, 0) 99%,
          rgba(125, 185, 232, 0) 100%
      );
      &:dir(rtl) {
        background: linear-gradient(
          to left,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.4) 50%,
          rgba(128, 186, 232, 0) 99%,
          rgba(125, 185, 232, 0) 100%
        );
      }
    }
    @keyframes slide {
      0% {
          transform: translateX(calc(-100% * (1 - 2 * var(--league-is-rtl))));
      }
      100% {
          transform: translateX(100%);
      }
    }
`;
var SkeletonCardFlex = genesisStyled16(Flex23)`
  & > *:last-child {
      margin-inline-end: 0em !important;
    }
  }
`;
var SkeletonCards = (_a) => {
  var _b = _a, {
    numCards = 1,
    height = "100px"
  } = _b, props = __objRest(_b, [
    "numCards",
    "height"
  ]);
  const cards = [];
  for (let i = 0; i < numCards; i += 1)
    cards.push(
      /* @__PURE__ */ React57.createElement(
        SkeletonBox,
        __spreadValues({
          key: i,
          marginInlineEnd: "one",
          height
        }, props)
      )
    );
  return /* @__PURE__ */ React57.createElement(SkeletonCardFlex, { justifyContent: "space-between" }, cards);
};

// src/components/user-dropdown/user-dropdown.component.tsx
import React62, { useRef as useRef5, useState as useState4 } from "react";
import { Flex as Flex24 } from "@leagueplatform/genesis-commons";
import { trackAnalyticsEvent as trackAnalyticsEvent3 } from "@leagueplatform/analytics";
import { useHandleDropdown } from "@leagueplatform/web-common";
import { queryHelpers as queryHelpers3, useMediaQuery as useMediaQuery3 } from "@leagueplatform/genesis-core";

// src/components/user-dropdown/user-dropdown.user-bar.component.tsx
import React58 from "react";
import { useIntl as useIntl19 } from "@leagueplatform/locales";
import {
  Button as Button6,
  Icon as Icon5,
  VisuallyHidden as VisuallyHidden8
} from "@leagueplatform/genesis-core";
var UserBar = ({
  label,
  isOpen,
  onClick,
  buttonProps,
  iconProps
}) => {
  const { formatMessage } = useIntl19();
  return /* @__PURE__ */ React58.createElement(
    Button6,
    __spreadProps(__spreadValues({
      id: "user_dropdown_menu_button",
      onClick,
      "aria-haspopup": "dialog",
      "aria-expanded": isOpen,
      "aria-controls": "user_dropdown_menu",
      size: "toolbar",
      priority: "tertiary"
    }, buttonProps), {
      css: __spreadValues({
        fontSize: "$bodyTwo",
        fontWeight: 500,
        borderRadius: "$none",
        border: "$none",
        span: { display: "flex", alignItems: "center" },
        "&:hover": {
          color: "$onSurfaceTextPrimary"
        }
      }, buttonProps == null ? void 0 : buttonProps.css)
    }),
    label,
    /* @__PURE__ */ React58.createElement(VisuallyHidden8, null, formatMessage({ id: "USER_DROPDOWN_BTN_LABEL" })),
    /* @__PURE__ */ React58.createElement(
      Icon5,
      __spreadProps(__spreadValues({
        icon: "interfaceChevronDown",
        size: "$oneAndHalf"
      }, iconProps), {
        css: __spreadValues({
          marginInlineStart: "$quarter",
          transform: isOpen ? "rotate(180deg)" : "rotate(0)",
          transition: "transform 0.5s ease"
        }, iconProps == null ? void 0 : iconProps.css)
      })
    )
  );
};

// src/components/user-dropdown/user-dropdown.dropdown.component.tsx
import React61, { useRef as useRef4 } from "react";
import { EVENT_NAME as EVENT_NAME2, trackAnalyticsEvent as trackAnalyticsEvent2 } from "@leagueplatform/analytics";
import { Box as Box30 } from "@leagueplatform/genesis-core";
import {
  useListItemsFocusHook,
  usePreventScroll
} from "@leagueplatform/web-common";

// src/components/user-dropdown/user-dropdown.dropdown-styles.ts
import { Box as Box28, css as css11, genesisStyled as genesisStyled17 } from "@leagueplatform/genesis-commons";
var DROPDOWN_MEGA_TOOLTIP_WIDTH = 260;
var DROPDOWN_MEGA_TOOLTIP_MOBILE_WIDTH = "100%";
var DROPDOWN_MEGA_TOOLTIP_MOBILE_HEIGHT = "337px";
var SPACE_BELOW_BUTTON_AND_ARROW = "62px";
var MOBILE_SPACE_BELOW_BUTTON_AND_ARROW = "48px";
var BORDER_WIDTH = 10;
var OVERLAY_Z_INDEX = 998;
var TOOLTIP_Z_INDEX = 999;
var DropdownMegaTooltipBase = genesisStyled17(Box28)(
  ({ isOpen }) => css11({
    padding: "one",
    transitionProperty: "opacity",
    transitionDuration: "250ms",
    animationTimingFunction: "ease",
    opacity: isOpen ? "1" : "0",
    listStyle: "none",
    position: "absolute",
    display: isOpen ? "flex" : "auto",
    flexDirection: "column",
    border: "thin",
    backgroundColor: "interactive.background.default",
    boxShadow: "0px 3px 4px rgba(0, 0, 0, 0.15)",
    borderRadius: "9px",
    zIndex: TOOLTIP_Z_INDEX,
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      bottom: "100%",
      width: 0,
      height: 0,
      borderWidth: `${BORDER_WIDTH}px`,
      borderStyle: "solid",
      borderColor: "transparent",
      borderBottomColor: "interactive.background.default",
      borderTop: "none"
    }
  })
);
var DropdownMegaTooltip = genesisStyled17(DropdownMegaTooltipBase)(
  css11({
    gap: "0",
    insetInlineEnd: "0",
    top: SPACE_BELOW_BUTTON_AND_ARROW,
    marginInlineEnd: "-10px",
    minHeight: "auto",
    width: DROPDOWN_MEGA_TOOLTIP_WIDTH,
    "&:after": {
      insetInlineEnd: "10px"
    }
  })
);
var DropdownMegaTooltipMobile = genesisStyled17(DropdownMegaTooltipBase)(
  css11({
    gap: "one",
    insetInlineStart: 0,
    top: MOBILE_SPACE_BELOW_BUTTON_AND_ARROW,
    minHeight: DROPDOWN_MEGA_TOOLTIP_MOBILE_HEIGHT,
    width: DROPDOWN_MEGA_TOOLTIP_MOBILE_WIDTH,
    borderRadius: "0 0 9px 9px"
  })
);
var Overlay = genesisStyled17(Box28)({
  position: "fixed",
  top: MOBILE_SPACE_BELOW_BUTTON_AND_ARROW,
  insetInlineStart: 0,
  insetInlineEnd: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: OVERLAY_Z_INDEX
});

// src/components/user-dropdown/user-dropdown.dropdown-list.component.tsx
import React60 from "react";

// src/components/user-dropdown/user-dropdown.dropdown-item.component.tsx
import React59 from "react";
import { Link as Link7, VisuallyHidden as VisuallyHidden9 } from "@leagueplatform/genesis-commons";
import {
  Box as Box29,
  Divider,
  Icon as Icon6,
  ParagraphText as ParagraphText3,
  StackLayout as StackLayout7,
  styled as styled7
} from "@leagueplatform/genesis-core";
import { LinkLegacy as RouterLink2 } from "@leagueplatform/routing";
import { useIntl as useIntl20 } from "@leagueplatform/locales";
var NotificationDot = styled7(Box29, {
  borderRadius: "$circle",
  backgroundColor: "$criticalIcon",
  width: "$half",
  height: "$half"
});
var UserDropdownItem = React59.forwardRef(
  ({
    to,
    text,
    description,
    isMobile,
    onClick = () => {
    },
    target,
    hasNotification,
    linkProps = {},
    icon,
    isLastElementInSection,
    label
  }, ref) => {
    const { formatMessage } = useIntl20();
    const isExternalLink = to && /^[^(/|..)]/.test(to);
    const Component = (() => {
      if (!to)
        return "button";
      if (isExternalLink)
        return Link7;
      return RouterLink2;
    })();
    return /* @__PURE__ */ React59.createElement(Box29, { as: "li" }, /* @__PURE__ */ React59.createElement(
      Link7,
      __spreadValues({
        as: Component,
        className: "user-dropdown-item_link",
        to: !isExternalLink ? to : void 0,
        href: isExternalLink ? to : void 0,
        ref,
        hoverStyle: {
          textDecoration: "none !important",
          backgroundColor: "interactive.background.hovered"
        },
        fontSize: "body2",
        lineHeight: "body2",
        fontWeight: isMobile ? "bold" : "regular",
        color: isMobile ? "interactive.action.subdued" : "onSurface.text.primary",
        display: "block",
        padding: "half",
        marginBottom: "quarter",
        border: "none",
        backgroundColor: "transparent",
        width: "100%",
        textAlign: "start",
        onClick,
        target,
        "aria-describedby": hasNotification ? "dependent-notification-message" : ""
      }, linkProps),
      /* @__PURE__ */ React59.createElement(
        StackLayout7,
        {
          orientation: "horizontal",
          verticalAlignment: "center",
          spacing: "$half"
        },
        text,
        icon && /* @__PURE__ */ React59.createElement(
          Icon6,
          {
            icon,
            css: {
              height: "$one",
              width: "$one"
            },
            label
          }
        ),
        hasNotification && /* @__PURE__ */ React59.createElement(
          NotificationDot,
          {
            "aria-hidden": true,
            id: "dependent-notification-message",
            "aria-label": formatMessage({
              id: "DEPENDENT_NOTIFICATION_MESSAGE"
            })
          }
        ),
        target === "_blank" && /* @__PURE__ */ React59.createElement(VisuallyHidden9, { "data-testid": "new-tab-msg" }, formatMessage({ id: "OPENS_IN_A_NEW_TAB" }))
      ),
      description ? /* @__PURE__ */ React59.createElement(
        ParagraphText3,
        {
          size: "sm",
          emphasis: "subtle",
          css: { marginTop: "$quarter" }
        },
        description
      ) : null
    ), isLastElementInSection && /* @__PURE__ */ React59.createElement(
      Divider,
      {
        className: "user-dropdown_divider",
        css: __spreadValues({
          marginInlineStart: "$half",
          marginInlineEnd: "$half",
          width: "unset",
          borderWidth: "1px"
        }, isMobile && { marginTop: "$oneAndHalf" })
      }
    ));
  }
);

// src/components/user-dropdown/user-dropdown.dropdown-list.component.tsx
var DropdownList = ({ dropdownItemsConfig, onDropdownClick, isMobile, refsMenuItems }) => {
  const handleDropdownItemClick = (event, dropdownItem) => {
    onDropdownClick(dropdownItem.text);
    if (dropdownItem.onClick) {
      dropdownItem.onClick(event);
      event.preventDefault();
    }
  };
  return /* @__PURE__ */ React60.createElement(React60.Fragment, null, dropdownItemsConfig.map((section, sectionIndex) => {
    const items = section.map(
      (dropdownItem, elementIndex) => /* @__PURE__ */ React60.createElement(
        UserDropdownItem,
        __spreadProps(__spreadValues({}, dropdownItem), {
          isMobile,
          key: dropdownItem.text,
          onClick: (event) => handleDropdownItemClick(event, dropdownItem),
          ref: (node) => {
            if (node) {
              refsMenuItems.push(node);
            }
          },
          isLastElementInSection: sectionIndex < dropdownItemsConfig.length - 1 && elementIndex === section.length - 1
        })
      )
    );
    return items;
  }));
};

// src/components/user-dropdown/user-dropdown.dropdown.component.tsx
var UserDropdown = ({
  isOpen,
  isMobile,
  setIsOpen,
  dropdownItemsConfig = [],
  getDropdownItemAnalyticsProps
}) => {
  const refsMenuItems = [];
  const refContainer = useRef4();
  useListItemsFocusHook(isOpen, refsMenuItems, refContainer);
  usePreventScroll(isMobile && isOpen);
  const formattedName = (action) => {
    var _a;
    return (_a = action == null ? void 0 : action.toLocaleLowerCase()) == null ? void 0 : _a.replace(/_/g, " ");
  };
  const onDropdownClick = (action) => {
    setIsOpen(false);
    trackAnalyticsEvent2(
      EVENT_NAME2.BUTTON_CLICKED,
      getDropdownItemAnalyticsProps == null ? void 0 : getDropdownItemAnalyticsProps(formattedName(action))
    );
  };
  if (isMobile) {
    return /* @__PURE__ */ React61.createElement(Box30, null, isOpen && /* @__PURE__ */ React61.createElement(Overlay, { onClick: () => setIsOpen(false) }), /* @__PURE__ */ React61.createElement(
      DropdownMegaTooltipMobile,
      {
        as: "ul",
        isOpen,
        isMobile,
        id: "user_dropdown_menu",
        role: "dialog",
        ref: refContainer,
        hidden: !isOpen
      },
      /* @__PURE__ */ React61.createElement(
        DropdownList,
        {
          dropdownItemsConfig,
          onDropdownClick,
          isMobile,
          refsMenuItems
        }
      )
    ));
  }
  return /* @__PURE__ */ React61.createElement(
    DropdownMegaTooltip,
    {
      as: "ul",
      isOpen,
      isMobile,
      id: "user_dropdown_menu",
      role: "dialog",
      ref: refContainer,
      hidden: !isOpen
    },
    /* @__PURE__ */ React61.createElement(
      DropdownList,
      {
        dropdownItemsConfig,
        onDropdownClick,
        isMobile,
        refsMenuItems
      }
    )
  );
};

// src/components/user-dropdown/user-dropdown.component.tsx
var UserDropdownComponent = ({
  label,
  dropdownItemsConfig = [],
  userBarProps = {},
  userBarAnalyticsProps,
  enableMobileRedesign = false,
  getDropdownItemAnalyticsProps = (action) => {
    var _a, _b;
    return {
      detail: action,
      product_area: (_a = userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.props) == null ? void 0 : _a.product_area,
      screen_name: (_b = userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.props) == null ? void 0 : _b.detail
    };
  }
}) => {
  const isMobile = Boolean(
    useMediaQuery3(queryHelpers3.down("mobileLandscape")) && enableMobileRedesign
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState4(false);
  const dropdownRef = useRef5(null);
  useHandleDropdown({
    isOpen: isDropdownOpen,
    setIsOpen: setIsDropdownOpen,
    ref: dropdownRef
  });
  const toggleDropdown = (event) => {
    if (isDropdownOpen === false) {
      trackAnalyticsEvent3(
        (userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.name) || "",
        userBarAnalyticsProps == null ? void 0 : userBarAnalyticsProps.props
      );
    }
    event.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };
  return /* @__PURE__ */ React62.createElement(
    Flex24,
    {
      color: "onSurface.text.primary",
      justifyContent: "center",
      position: isMobile ? "static" : "relative",
      ref: dropdownRef
    },
    /* @__PURE__ */ React62.createElement(
      UserBar,
      __spreadValues({
        label,
        isOpen: isDropdownOpen,
        onClick: toggleDropdown
      }, userBarProps)
    ),
    /* @__PURE__ */ React62.createElement(
      UserDropdown,
      {
        isOpen: isDropdownOpen,
        isMobile,
        setIsOpen: setIsDropdownOpen,
        dropdownItemsConfig,
        getDropdownItemAnalyticsProps
      }
    )
  );
};

// src/components/animations/fade-and-grow.tsx
import React63 from "react";
import { Box as Box31, css as css12, genesisStyled as genesisStyled18 } from "@leagueplatform/genesis-commons";
import { Transition as Transition2 } from "react-transition-group";
var Element = genesisStyled18(Box31)(
  ({ stylesProp }) => css12(__spreadProps(__spreadValues({}, stylesProp), {
    opacity: 0
  }))
);
var transitionStyles = {
  entering: {
    opacity: 0,
    visibility: "visible",
    maxHeight: "90vh",
    overflow: "hidden"
  },
  entered: {
    opacity: 1,
    visibility: "visible",
    maxHeight: "90vh",
    overflowY: "auto"
  },
  exiting: {
    opacity: 0,
    visibility: "hidden",
    maxHeight: "0px",
    overflow: "hidden"
  },
  exited: {
    opacity: 0,
    visibility: "hidden",
    maxHeight: "0px"
  }
};
var FadeAndGrow = ({
  isActive,
  stylesProp,
  duration,
  children = null
}) => {
  const halfTime = duration / 2;
  return /* @__PURE__ */ React63.createElement(Transition2, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React63.createElement(
    Element,
    {
      stylesProp: __spreadProps(__spreadValues({}, stylesProp), {
        overflow: "hidden",
        transition: `opacity ${halfTime}ms ease-in-out, max-height ${duration}ms ease-in-out ${halfTime}ms, visibility ${duration}ms ease-in-out ${halfTime}ms`
      }),
      style: __spreadValues({}, transitionStyles[state])
    },
    children && children
  ));
};

// src/components/animations/fade-in.tsx
import React64 from "react";
import { Box as Box32, css as css13, genesisStyled as genesisStyled19 } from "@leagueplatform/genesis-commons";
import { Transition as Transition3 } from "react-transition-group";
var Element2 = genesisStyled19(Box32)(
  ({ stylesProp }) => css13(__spreadProps(__spreadValues({}, stylesProp), {
    opacity: 0
  }))
);
var transitionStyles2 = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 }
};
var FadeIn = ({
  isActive,
  stylesProp,
  duration,
  children = null
}) => /* @__PURE__ */ React64.createElement(Transition3, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React64.createElement(
  Element2,
  {
    stylesProp: __spreadProps(__spreadValues({}, stylesProp), {
      transition: `opacity ${duration}ms ease-in-out`
    }),
    style: __spreadValues({}, transitionStyles2[state])
  },
  children && children
));

// src/components/animations/grow.tsx
import React65 from "react";
import { Box as Box33, css as css14, genesisStyled as genesisStyled20 } from "@leagueplatform/genesis-commons";
import { Transition as Transition4 } from "react-transition-group";
var Element3 = genesisStyled20(Box33)(
  ({ styles }) => css14(__spreadProps(__spreadValues({}, styles), {
    width: 0,
    overflow: "hidden"
  }))
);
var transitionStyles3 = {
  entering: { width: "100%" },
  entered: { width: "100%" },
  exiting: { width: 0 },
  exited: { width: 0 }
};
var Grow = ({
  isActive,
  stylesProp,
  duration,
  children = null
}) => /* @__PURE__ */ React65.createElement(Transition4, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React65.createElement(
  Element3,
  {
    styles: __spreadProps(__spreadValues({}, stylesProp), {
      transition: `width ${duration}ms ease-in-out`
    }),
    style: __spreadValues({}, transitionStyles3[state])
  },
  children && children
));

// src/components/animations/slide-in-horizontal.tsx
import React66 from "react";
import { Box as Box34, css as css15, genesisStyled as genesisStyled21 } from "@leagueplatform/genesis-commons";
import { Transition as Transition5 } from "react-transition-group";
var Element4 = genesisStyled21(Box34)(
  ({ stylesProp }) => css15(__spreadValues({}, stylesProp))
);
var SlideInHorizontal = ({
  isActive,
  stylesProp,
  duration,
  distance = "-100%",
  children = null
}) => {
  const transitionStyles4 = {
    entering: { transform: `translateX(0)` },
    entered: { transform: `translateX(0)` },
    exiting: { transform: `translateX(0)` },
    exited: {
      transform: `translateX(calc(${distance} * (1 - 2 * var(--league-is-rtl))))`
    }
  };
  return /* @__PURE__ */ React66.createElement(Transition5, { in: isActive, timeout: duration }, (state) => /* @__PURE__ */ React66.createElement(
    Element4,
    {
      stylesProp: __spreadProps(__spreadValues({}, stylesProp), {
        transition: `transform ${duration}ms ease-in-out`
      }),
      style: __spreadValues({}, transitionStyles4[state])
    },
    children && children
  ));
};

// src/components/language-selector-dropdown/language-selector.component.jsx
import React70, { useState as useState5, useRef as useRef6, useContext } from "react";
import { Flex as Flex27 } from "@leagueplatform/genesis-commons";
import { LocaleContext } from "@leagueplatform/locales";
import { useHandleDropdown as useHandleDropdown2 } from "@leagueplatform/web-common";

// src/components/language-selector-dropdown/language-selector-bar.component.jsx
import React67 from "react";
import PropTypes9 from "prop-types";
import { Flex as Flex25, Text, Image as Image8 } from "@leagueplatform/genesis-commons";
import CHEVRON from "./assets/chevron-down.svg";
var LanguageBar = ({ onClick, isOpen, selectedLanguage }) => {
  let shortLocale = selectedLanguage;
  if (selectedLanguage.includes("-")) {
    shortLocale = selectedLanguage.substring(0, selectedLanguage.indexOf("-"));
  }
  return /* @__PURE__ */ React67.createElement(
    Flex25,
    {
      as: "button",
      background: "none",
      onClick,
      border: "none",
      alignItems: "center",
      "aria-haspopup": "true",
      "aria-expanded": isOpen,
      "aria-controls": "language_selector_dropdown_menu",
      focusStyle: {
        outline: 0,
        boxShadow: "focusRing",
        borderWidth: "thin",
        borderColor: "decorative.brand.primary.bright"
      },
      cursor: "pointer"
    },
    /* @__PURE__ */ React67.createElement(
      Text,
      {
        as: "p",
        color: "onSurface.text.subdued",
        fontSize: "subtitle3",
        display: "inline",
        marginInlineEnd: "half",
        fontWeight: "medium",
        hoverStyle: {
          color: "onSurface.text.primary"
        }
      },
      shortLocale.toUpperCase()
    ),
    /* @__PURE__ */ React67.createElement(
      Image8,
      {
        src: CHEVRON,
        alt: "",
        height: "threeQuarters",
        transition: "transform 0.5s ease",
        transform: isOpen ? "rotate(180deg)" : "rotate(0)",
        role: "presentation"
      }
    )
  );
};
LanguageBar.defaultProps = { isOpen: false };
LanguageBar.propTypes = {
  isOpen: PropTypes9.bool,
  onClick: PropTypes9.func.isRequired,
  selectedLanguage: PropTypes9.string.isRequired
};

// src/components/language-selector-dropdown/language-selector-dropdown.component.tsx
import React69 from "react";
import {
  DEFAULT_LOCALE,
  supportedLocaleMapping
} from "@leagueplatform/locales";

// src/components/language-selector-dropdown/language-selector-dropdown-item.component.jsx
import React68 from "react";
import PropTypes10 from "prop-types";
import { Box as Box35, Image as Image9, Flex as Flex26 } from "@leagueplatform/genesis-commons";
import { useIntl as useIntl21 } from "@leagueplatform/locales";
import CHECKMARK from "./assets/checkmark.svg";
var DropdownItem = ({ setLanguage, isSelected, locale }) => {
  const { $tmap } = useIntl21();
  const localeName = $tmap({
    en: "LANGUAGE_SELECTOR_ENGLISH",
    fr: "LANGUAGE_SELECTOR_FRENCH",
    "es-MX": "LANGUAGE_SELECTOR_SPANISH"
  })(locale);
  return /* @__PURE__ */ React68.createElement(Box35, { as: "li", role: "menuitem" }, /* @__PURE__ */ React68.createElement(
    Flex26,
    {
      as: "button",
      href: "#",
      lang: locale,
      fontSize: "body2",
      lineHeight: "body2",
      fontWeight: "regular",
      color: "onSurface.text.primary",
      padding: "half",
      marginBottom: "quarter",
      border: "none",
      backgroundColor: "transparent",
      width: "100%",
      textAlign: "start",
      hoverStyle: {
        textDecoration: "none !important",
        backgroundColor: "highlight.background.subdued",
        cursor: "pointer"
      },
      alignItems: "center",
      onClick: setLanguage
    },
    localeName,
    isSelected && /* @__PURE__ */ React68.createElement(
      Image9,
      {
        src: CHECKMARK,
        alt: "",
        height: "9px",
        paddingInlineStart: "half"
      }
    )
  ));
};
DropdownItem.defaultProps = {
  isSelected: false
};
DropdownItem.propTypes = {
  locale: PropTypes10.string.isRequired,
  setLanguage: PropTypes10.func.isRequired,
  isSelected: PropTypes10.bool
};

// src/components/language-selector-dropdown/language-selector-dropdown.constants.ts
var DROPDOWN_MEGA_TOOLTIP_WIDTH2 = 250;
var SPACE_BELOW_BUTTON_AND_ARROW2 = "62px";
var SPACE_INLINE_END_OF_DROPDOWN = "-35px";
var BORDER_WIDTH2 = 10;

// src/components/language-selector-dropdown/dropdown-tooltip.component.ts
import { Box as Box36, genesisStyled as genesisStyled22, css as css16 } from "@leagueplatform/genesis-commons";
var DropdownTooltip = genesisStyled22(Box36)(
  ({ isOpen }) => css16({
    transitionProperty: "opacity",
    transitionDuration: "250ms",
    animationTimingFunction: "ease",
    opacity: isOpen ? "1" : "0",
    "&:after": {
      content: '""',
      backgroundColor: "transparent",
      display: "block",
      position: "absolute",
      insetInlineStart: `calc(80% - ${BORDER_WIDTH2}px)`,
      bottom: "100%",
      width: 0,
      height: 0,
      borderWidth: `${BORDER_WIDTH2}px`,
      borderStyle: "solid",
      borderColor: "transparent",
      borderBottomColor: "surface.background.primary",
      borderTop: "none"
    }
  })
);

// src/components/language-selector-dropdown/language-selector-dropdown.component.tsx
var Dropdown = ({
  isOpen = false,
  setLanguage,
  selectedLanguage,
  countryCode
}) => /* @__PURE__ */ React69.createElement(
  DropdownTooltip,
  {
    position: "absolute",
    as: "ul",
    width: DROPDOWN_MEGA_TOOLTIP_WIDTH2,
    backgroundColor: "surface.background.primary",
    boxShadow: "dropdown",
    border: "thin",
    top: SPACE_BELOW_BUTTON_AND_ARROW2,
    insetInlineEnd: SPACE_INLINE_END_OF_DROPDOWN,
    borderRadius: "medium",
    padding: "one",
    isOpen,
    id: "language_selector_dropdown_menu",
    role: "menu",
    hidden: !isOpen
  },
  supportedLocaleMapping[countryCode] ? supportedLocaleMapping[countryCode].map((locale) => /* @__PURE__ */ React69.createElement(
    DropdownItem,
    {
      locale,
      isSelected: selectedLanguage === locale,
      key: locale,
      setLanguage: () => {
        setLanguage(locale);
        document.location.reload();
      }
    }
  )) : /* @__PURE__ */ React69.createElement(
    DropdownItem,
    {
      locale: DEFAULT_LOCALE,
      isSelected: selectedLanguage === DEFAULT_LOCALE,
      setLanguage: () => {
        setLanguage(DEFAULT_LOCALE);
      }
    }
  )
);

// src/components/language-selector-dropdown/use-user-country-code.hook.js
import {
  getGroup,
  GET_GROUP_MESSAGE_TYPE,
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE
} from "@leagueplatform/user-profile-api";
import { useQuery } from "react-query";
var getGroupId = (userProfileData) => {
  var _a;
  return (_a = userProfileData == null ? void 0 : userProfileData.groups) == null ? void 0 : _a.find(
    (group) => group.state === "active" || group.state === "initial"
  ).group_id;
};
function useUserCountryCode() {
  var _a, _b;
  const groupIdQuery = useQuery(
    [GET_USER_PROFILE_MESSAGE_TYPE],
    () => getUserProfile(),
    { select: (data) => getGroupId(data) }
  );
  const groupMessageTypeQuery = useQuery(
    [GET_GROUP_MESSAGE_TYPE],
    () => getGroup(String(groupIdQuery.data)),
    { enabled: !!groupIdQuery.data }
  );
  return (_b = (_a = groupMessageTypeQuery == null ? void 0 : groupMessageTypeQuery.data) == null ? void 0 : _a.group) == null ? void 0 : _b.country_code;
}

// src/components/language-selector-dropdown/language-selector.component.jsx
var LanguageSelector = () => {
  const { locale, setLocale } = useContext(LocaleContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState5(false);
  const dropdownRef = useRef6(null);
  const countryCode = useUserCountryCode();
  useHandleDropdown2({
    isOpen: isDropdownOpen,
    setIsOpen: setIsDropdownOpen,
    ref: dropdownRef
  });
  const toggleDropdown = (event) => {
    event.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };
  return /* @__PURE__ */ React70.createElement(
    Flex27,
    {
      justifyContent: "center",
      position: "relative",
      ref: dropdownRef,
      backgroundColor: "surface.background.primary"
    },
    /* @__PURE__ */ React70.createElement(
      LanguageBar,
      {
        "aria-controls": "language_dropdown_menu",
        "aria-expanded": isDropdownOpen,
        "aria-haspopup": "true",
        isOpen: isDropdownOpen,
        onClick: toggleDropdown,
        selectedLanguage: locale
      }
    ),
    /* @__PURE__ */ React70.createElement(
      Dropdown,
      {
        isOpen: isDropdownOpen,
        setIsOpen: setIsDropdownOpen,
        selectedLanguage: locale,
        setLanguage: setLocale,
        countryCode
      }
    )
  );
};

// src/components/progress-bar/progress-bar.component.tsx
import React71 from "react";
import {
  css as css17,
  Flex as Flex28,
  Box as Box37,
  genesisStyled as genesisStyled23,
  VisuallyHidden as VisuallyHidden10
} from "@leagueplatform/genesis-commons";
import { usePrefersReducedMotion } from "@leagueplatform/web-common";
import uniqueId2 from "lodash/uniqueId";
var Bar = genesisStyled23(Flex28)(
  css17({
    height: "1rem",
    minHeight: "10px",
    width: "100%",
    borderRadius: "59px",
    position: "relative",
    overflow: "hidden"
  })
);
var ProgressIndicator = genesisStyled23(Box37)(
  ({ customBackgroundColor, percentage, reducedMotion }) => css17({
    backgroundColor: customBackgroundColor,
    width: `${percentage}%`,
    transition: reducedMotion ? "width 2s linear" : "none",
    animation: reducedMotion ? "none" : "barWidth 1s ease-in-out forwards",
    "@keyframes barWidth": {
      from: {
        width: "0%"
      }
    }
  })
);
var ProgressBar = ({
  customBarFillColor = "primary.background.default",
  customBarBackgroundColor = "interactive.background.disabled",
  current,
  total = 100,
  // If no total is provided, assumption is current is a percentages so total would be 100
  screenReaderText = `${total ? Number(current / total * 100) : current}%`
}) => {
  const reducedMotion = usePrefersReducedMotion();
  const id = uniqueId2("progress-bar");
  const currentAsPercentage = total ? Number(current / total * 100) : current;
  return /* @__PURE__ */ React71.createElement("div", null, /* @__PURE__ */ React71.createElement(VisuallyHidden10, null, /* @__PURE__ */ React71.createElement("label", { htmlFor: id }, screenReaderText), /* @__PURE__ */ React71.createElement("progress", { id, max: total, value: current })), /* @__PURE__ */ React71.createElement(
    Bar,
    {
      "data-testid": "progress-bar",
      "aria-hidden": true,
      backgroundColor: customBarBackgroundColor
    },
    /* @__PURE__ */ React71.createElement(
      ProgressIndicator,
      {
        customBackgroundColor: customBarFillColor,
        height: "100%",
        borderEndEndRadius: "pill",
        borderStartEndRadius: "pill",
        percentage: currentAsPercentage,
        reducedMotion
      }
    )
  ));
};

// src/components/conditional-link-card/conditional-link-card.component.tsx
import React72, { useRef as useRef7 } from "react";
import {
  Flex as Flex29,
  css as css18,
  genesisStyled as genesisStyled24
} from "@leagueplatform/genesis-commons";
var LinkCardWrapper = genesisStyled24(Flex29)(
  css18({
    "&:hover, &:focus-within": {
      boxShadow: "focusOutline",
      borderRadius: "medium",
      cursor: "pointer"
    },
    a: {
      "&:hover": {
        textDecoration: "none"
      },
      "&:focus": {
        borderColor: "none",
        "&::before": {
          boxShadow: "none"
        }
      }
    }
  })
);
var ConditionalLinkCard = ({
  children,
  hasLink,
  cardStyle = {},
  linkRef,
  onClick = () => {
  }
}) => {
  const Card3 = hasLink ? LinkCardWrapper : Flex29;
  const cardRef = useRef7(null);
  const handleCardClick = () => {
    var _a;
    (_a = linkRef == null ? void 0 : linkRef.current) == null ? void 0 : _a.click();
    onClick();
  };
  return /* @__PURE__ */ React72.createElement(
    Card3,
    __spreadValues({
      ref: cardRef,
      flex: 1,
      boxShadow: "card",
      backgroundColor: "surface.background.primary",
      borderRadius: "large",
      borderStyle: "solid",
      onClick: handleCardClick
    }, cardStyle),
    children
  );
};

// src/components/conditional-link/conditional-link.component.tsx
import React73, { forwardRef as forwardRef3 } from "react";
import { TextAction as TextAction5 } from "@leagueplatform/genesis-core";
import { normalizeInternalUrl } from "@leagueplatform/web-common";
var ConditionalLink = forwardRef3((_a, ref) => {
  var _b = _a, { url, children, onClick = () => {
  } } = _b, linkProps = __objRest(_b, ["url", "children", "onClick"]);
  if (url) {
    const href = normalizeInternalUrl(url);
    return /* @__PURE__ */ React73.createElement(
      InternalOrExternalLinkButton,
      __spreadValues({
        baseComponent: TextAction5,
        onClick: (e) => {
          e.stopPropagation();
          onClick(e);
        },
        ref,
        href,
        css: {
          "&&": {
            all: "inherit"
          },
          "&:focus": {
            outline: "unset !important"
          }
        }
      }, linkProps),
      children
    );
  }
  return children;
});

// src/components/progress-ring/progress-ring.component.tsx
import React74 from "react";
import {
  css as css19,
  Flex as Flex30,
  genesisStyled as genesisStyled25,
  VisuallyHidden as VisuallyHidden11,
  Image as Image10,
  useTheme as useTheme2
} from "@leagueplatform/genesis-commons";
import { usePrefersReducedMotion as usePrefersReducedMotion2 } from "@leagueplatform/web-common";
import uniqueId3 from "lodash/uniqueId";
var ProgressRingWrapper = genesisStyled25("svg")(
  ({ width, height }) => css19({
    width,
    height,
    transform: "rotate(-90deg)"
  })
);
var Progress = genesisStyled25("circle")(
  ({ stroke, reducedMotion, dash, circumference }) => css19({
    fill: "transparent",
    stroke,
    strokeLinecap: "round",
    transition: reducedMotion ? "stroke-dasharray 2s linear" : "none",
    strokeDasharray: `${dash}, ${circumference - dash}`,
    animation: reducedMotion ? "none" : "dashArray 1s ease-in-out forwards",
    "@keyframes dashArray": {
      from: {
        strokeDasharray: `0, ${circumference}`
      }
    }
  })
);
var Track = genesisStyled25("circle")(
  ({ stroke }) => css19({
    fill: "transparent",
    stroke,
    strokeDasharray: 0
  })
);
var CenteredImageWrapper = genesisStyled25(Flex30)(
  css19({
    borderRadius: "circle",
    overflow: "hidden",
    position: "absolute",
    top: "50%",
    insetInlineStart: "50%",
    transform: "translate(-50%, -50%)",
    alignItems: "center",
    justifyContent: "center"
  })
);
var ProgressRing = ({
  customRingFillColor = "primary.background.default",
  customRingBackgroundColor = "interactive.background.disabled",
  current,
  total,
  screenReaderText = `${Number(current / total * 100)}%`,
  image,
  size = 82,
  strokeWidth = 12,
  imageAltText = ""
}) => {
  const { space } = useTheme2();
  const reducedMotion = usePrefersReducedMotion2();
  const currentAsPercentage = Number(current / total * 100);
  const radius = (size - strokeWidth) / 2;
  const circumference = Math.PI * radius * 2;
  const dash = currentAsPercentage * circumference / 100;
  const id = uniqueId3("progress-ring");
  return /* @__PURE__ */ React74.createElement("div", null, /* @__PURE__ */ React74.createElement(VisuallyHidden11, null, /* @__PURE__ */ React74.createElement("label", { htmlFor: id }, screenReaderText), /* @__PURE__ */ React74.createElement("progress", { id, max: total, value: current })), /* @__PURE__ */ React74.createElement(Flex30, { alignItems: "center", justifyContent: "center", position: "relative" }, /* @__PURE__ */ React74.createElement(ProgressRingWrapper, { width: size, height: size }, /* @__PURE__ */ React74.createElement(
    Track,
    {
      stroke: customRingBackgroundColor,
      strokeWidth: `${strokeWidth}px`,
      cx: size / 2,
      cy: size / 2,
      r: radius
    }
  ), /* @__PURE__ */ React74.createElement(
    Progress,
    {
      stroke: customRingFillColor,
      strokeWidth: `${strokeWidth}px`,
      cx: size / 2,
      cy: size / 2,
      r: radius,
      dash,
      circumference,
      reducedMotion
    }
  )), image && /* @__PURE__ */ React74.createElement(
    CenteredImageWrapper,
    {
      width: size - (strokeWidth + space.half) * 2,
      height: size - (strokeWidth + space.half) * 2
    },
    /* @__PURE__ */ React74.createElement(Image10, { src: image, alt: imageAltText })
  )));
};

// src/components/highlight-card/highlight-card.tsx
import * as React75 from "react";
import { useIntl as useIntl22 } from "@leagueplatform/locales";
import {
  Card,
  HeadingText as HeadingText4,
  StackLayout as StackLayout8,
  TextAction as TextAction6
} from "@leagueplatform/genesis-core";
function HighlightCard({
  title,
  actionLink,
  actionText,
  children,
  onClick
}) {
  const { formatMessage } = useIntl22();
  const displayText = actionText || formatMessage({ id: "SEE_MORE" });
  return /* @__PURE__ */ React75.createElement(Card.Elevated, { css: { backgroundColor: "$surfaceCardSecondary" } }, /* @__PURE__ */ React75.createElement(Card.Section, null, /* @__PURE__ */ React75.createElement(
    StackLayout8,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceBetween",
      verticalAlignment: "center",
      css: { marginBottom: "$one" }
    },
    /* @__PURE__ */ React75.createElement(HeadingText4, { level: "3", size: "lg" }, title),
    /* @__PURE__ */ React75.createElement(
      TextAction6,
      {
        href: actionLink,
        onClick,
        css: {
          typography: "$buttonTwo"
        }
      },
      displayText
    )
  ), children));
}

// src/components/callout-banner/callout-banner.tsx
import * as React76 from "react";
import {
  StackLayout as StackLayout9,
  Card as Card2,
  Icon as Icon7
} from "@leagueplatform/genesis-core";
function CalloutBanner({ icon, label, children }) {
  return /* @__PURE__ */ React76.createElement(Card2.Flat, { css: { backgroundColor: "$surfaceCardPrimary" } }, /* @__PURE__ */ React76.createElement(Card2.Section, { padding: "$threeQuarters" }, /* @__PURE__ */ React76.createElement(
    StackLayout9,
    {
      orientation: "horizontal",
      spacing: "$half",
      verticalAlignment: "center"
    },
    /* @__PURE__ */ React76.createElement(
      Icon7,
      {
        css: {
          borderRadius: "$circle",
          backgroundColor: "$surfaceBackgroundPrimary",
          objectFit: "scale-down"
        },
        size: "$twoAndHalf",
        icon,
        label
      }
    ),
    children
  )));
}

// src/components/external-redirect/external-redirect.component.tsx
import React77 from "react";
var ExternalRedirect = ({ to }) => {
  React77.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};

// src/components/badge/badge.component.tsx
import React79, { createElement as createElement13 } from "react";
import {
  StackLayout as StackLayout11
} from "@leagueplatform/genesis-core";

// src/components/icon-text/icon-text.component.tsx
import * as React78 from "react";
import {
  UtilityText,
  StackLayout as StackLayout10,
  Icon as Icon8
} from "@leagueplatform/genesis-core";
var IconText = ({ iconProps, text }) => /* @__PURE__ */ React78.createElement(
  StackLayout10,
  {
    orientation: "horizontal",
    spacing: "$quarter",
    verticalAlignment: "center"
  },
  /* @__PURE__ */ React78.createElement(Icon8, __spreadValues({ size: "$one" }, iconProps)),
  typeof text === "string" ? /* @__PURE__ */ React78.createElement(UtilityText, null, text) : text
);

// src/components/badge/badge.component.tsx
var defaultCss = {
  backgroundColor: "$successBackgroundSubdued",
  borderRadius: "$pill",
  color: "$onSurfaceTextPrimary",
  flex: "initial",
  fontWeight: "$semibold",
  padding: "$quarter $half",
  textDecoration: "none",
  typography: "$subtitleTwo",
  width: "fit-content"
};
var Badge = (_a) => {
  var _b = _a, {
    iconTextProps,
    children,
    css: css20 = {}
  } = _b, other = __objRest(_b, [
    "iconTextProps",
    "children",
    "css"
  ]);
  return /* @__PURE__ */ React79.createElement(
    StackLayout11,
    __spreadValues({
      orientation: "horizontal",
      verticalAlignment: "center",
      spacing: "$quarter",
      css: __spreadValues(__spreadValues({}, defaultCss), css20)
    }, other),
    iconTextProps ? createElement13(IconText, iconTextProps) : children
  );
};

// src/components/calendar/calendar.tsx
import React80 from "react";
import {
  Button as Button7,
  Calendar,
  CalendarCell,
  CalendarGrid,
  CalendarGridBody,
  CalendarGridHeader,
  CalendarHeaderCell,
  Heading
} from "react-aria-components";
import {
  Box as Box38,
  styled as styled8,
  focusOutlineInner,
  Icon as Icon9,
  VisuallyHidden as VisuallyHidden12
} from "@leagueplatform/genesis-core";
import { useIntl as useIntl23 } from "@leagueplatform/locales";
var StyledCalendarFull = styled8(Box38, {
  ".calendar": {
    width: "677px",
    height: "100%",
    "@mobile": {
      width: "375px"
    }
  },
  ".calendar-grid-navigation": {
    display: "flex",
    justifyContent: "space-between"
  },
  ".calendar-grid-previous-button": {
    marginInlineStart: "$two",
    background: "none",
    border: "none"
  },
  ".calendar-grid-next-button": {
    marginInlineEnd: "$two",
    background: "none",
    border: "none"
  },
  ".calendar-grid-header": {
    marginBottom: "$half",
    tableLayout: "fixed",
    width: "100%",
    height: "100%"
  },
  ".calendar-grid-cell": {
    width: "44px",
    height: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 auto",
    cursor: "pointer",
    "&[data-selected]": __spreadProps(__spreadValues({}, focusOutlineInner), {
      color: "$onSurfaceTextReversed",
      background: "$surfaceBackgroundTertiary",
      borderRadius: 9999
    }),
    "&[data-disabled], &[data-unavailable]": {
      color: "$onSurfaceTextSubdued",
      cursor: "not-allowed"
    }
  }
});
var CalendarView = (_a) => {
  var _b = _a, {
    ChevronRight,
    ChevronLeft,
    css: css20
  } = _b, props = __objRest(_b, [
    "ChevronRight",
    "ChevronLeft",
    "css"
  ]);
  const { formatMessage } = useIntl23();
  return /* @__PURE__ */ React80.createElement("div", null, /* @__PURE__ */ React80.createElement(StyledCalendarFull, { css: css20 }, /* @__PURE__ */ React80.createElement(Calendar, __spreadProps(__spreadValues({}, props), { className: "calendar" }), /* @__PURE__ */ React80.createElement("div", { className: "calendar-grid-navigation" }, /* @__PURE__ */ React80.createElement(Button7, { slot: "previous", className: "calendar-grid-previous-button" }, /* @__PURE__ */ React80.createElement(Icon9, __spreadValues({ icon: "interfaceChevronBack" }, ChevronLeft)), /* @__PURE__ */ React80.createElement(VisuallyHidden12, null, formatMessage({ id: "PERVIOUS_MONTH" }))), /* @__PURE__ */ React80.createElement(Heading, null), /* @__PURE__ */ React80.createElement(Button7, { slot: "next", className: "calendar-grid-next-button" }, /* @__PURE__ */ React80.createElement(Icon9, __spreadValues({ icon: "interfaceChevronForward" }, ChevronRight)), /* @__PURE__ */ React80.createElement(VisuallyHidden12, null, formatMessage({ id: "NEXT_MONTH" })))), /* @__PURE__ */ React80.createElement(CalendarGrid, { weekdayStyle: "short", className: "calendar-grid-header" }, /* @__PURE__ */ React80.createElement(CalendarGridHeader, null, (day) => /* @__PURE__ */ React80.createElement(CalendarHeaderCell, null, day)), /* @__PURE__ */ React80.createElement(CalendarGridBody, { className: "calendar-grid-body" }, (date) => /* @__PURE__ */ React80.createElement(CalendarCell, { date, className: "calendar-grid-cell" }))))));
};

// src/components/action-menu/action-menu.component.tsx
import * as React81 from "react";
import { Box as Box39, UtilityText as UtilityText2 } from "@leagueplatform/genesis-core";

// src/hooks/use-action-menu-controls.hook.ts
import { useCallback as useCallback4, useEffect as useEffect6, useRef as useRef8, useState as useState6 } from "react";

// src/types/keyboard-actions.types.ts
var KeyboardActionTypes = /* @__PURE__ */ ((KeyboardActionTypes2) => {
  KeyboardActionTypes2["Close"] = "close";
  KeyboardActionTypes2["NextItem"] = "next-item";
  KeyboardActionTypes2["Open"] = "open";
  KeyboardActionTypes2["PrevItem"] = "prev-item";
  KeyboardActionTypes2["SelectItem"] = "select-item";
  return KeyboardActionTypes2;
})(KeyboardActionTypes || {});

// src/hooks/use-action-menu-controls.hook.ts
var keyboardActions = {
  menuOpen: [
    {
      key: "Escape" /* Escape */,
      action: "close" /* Close */
    },
    {
      key: "Tab" /* Tab */,
      action: "close" /* Close */
    },
    {
      key: "ArrowDown" /* ArrowDown */,
      action: "next-item" /* NextItem */,
      options: {
        preventDefault: true
      }
    },
    {
      key: "ArrowUp" /* ArrowUp */,
      action: "prev-item" /* PrevItem */,
      options: {
        preventDefault: true
      }
    },
    {
      key: "ArrowRight" /* ArrowRight */,
      action: "next-item" /* NextItem */
    },
    {
      key: "ArrowLeft" /* ArrowLeft */,
      action: "prev-item" /* PrevItem */
    },
    {
      key: "Enter" /* Enter */,
      action: "select-item" /* SelectItem */
    }
  ],
  menuClosed: [
    {
      key: " " /* Space */,
      action: "open" /* Open */,
      options: {
        preventDefault: true
      }
    },
    {
      key: "Enter" /* Enter */,
      action: "open" /* Open */
    },
    {
      key: "ArrowDown" /* ArrowDown */,
      action: "open" /* Open */
    },
    {
      key: "ArrowUp" /* ArrowUp */,
      action: "open" /* Open */,
      options: {
        focusLastItem: true
      }
    }
  ]
};
var useActionMenuControls = () => {
  const [isMenuOpen, setIsMenuOpen] = useState6(false);
  const [selectedItemId, setSelectedItemId] = useState6();
  const menuButtonRef = useRef8();
  const menuItemRefs = useRef8([]);
  const setMenuItemRef = (item) => {
    if (item && !menuItemRefs.current.includes(item)) {
      menuItemRefs.current.push(item);
    }
  };
  const getFocusedMenuItemIndex = () => menuItemRefs.current.findIndex((item) => item === document.activeElement);
  const getFocusedMenuItem = () => menuItemRefs.current.find((item) => item === document.activeElement);
  const isMenuButtonFocused = useCallback4(
    () => menuButtonRef.current === document.activeElement,
    []
  );
  const focusOnNextItem = useCallback4((focusLastItem = false) => {
    var _a;
    const activeKey = getFocusedMenuItemIndex();
    const lastKey = menuItemRefs.current.length - 1;
    let keyToFocus = focusLastItem ? activeKey - 1 : activeKey + 1;
    if (keyToFocus < 0)
      keyToFocus = lastKey;
    if (keyToFocus > lastKey)
      keyToFocus = 0;
    (_a = menuItemRefs.current[keyToFocus]) == null ? void 0 : _a.focus();
  }, []);
  const openMenu = useCallback4(
    (focusLastItem = false) => {
      setIsMenuOpen(true);
      focusOnNextItem(focusLastItem);
    },
    [focusOnNextItem]
  );
  const closeMenu = useCallback4(() => {
    var _a;
    (_a = menuButtonRef.current) == null ? void 0 : _a.focus();
    setIsMenuOpen(false);
  }, []);
  const toggleMenuOpen = useCallback4(() => {
    if (isMenuOpen)
      closeMenu();
    else
      openMenu();
  }, [isMenuOpen, closeMenu, openMenu]);
  const onKeyDown = useCallback4(
    (event) => {
      var _a, _b, _c;
      const { Close, Open, PrevItem, NextItem, SelectItem } = KeyboardActionTypes;
      if (isMenuOpen) {
        const action = keyboardActions.menuOpen.find(
          (act) => act.key === event.key
        );
        if ((_a = action == null ? void 0 : action.options) == null ? void 0 : _a.preventDefault) {
          event.preventDefault();
        }
        if (action && action.action === Close) {
          closeMenu();
        }
        if (action && [NextItem, PrevItem].includes(action.action)) {
          focusOnNextItem(action.action === PrevItem);
        }
        if (action && action.action === SelectItem) {
          const activeItem = getFocusedMenuItem();
          if (activeItem && activeItem.id) {
            setSelectedItemId(activeItem.id);
          }
        }
      }
      if (!isMenuOpen && isMenuButtonFocused()) {
        const action = keyboardActions.menuClosed.find(
          (act) => act.key === event.key
        );
        if ((_b = action == null ? void 0 : action.options) == null ? void 0 : _b.preventDefault) {
          event.preventDefault();
        }
        if (action && action.action === Open) {
          openMenu((_c = action == null ? void 0 : action.options) == null ? void 0 : _c.focusLastItem);
        }
      }
    },
    [closeMenu, openMenu, isMenuOpen, focusOnNextItem, isMenuButtonFocused]
  );
  useEffect6(() => {
    if (isMenuOpen && selectedItemId !== void 0) {
      closeMenu();
    }
  }, [isMenuOpen, selectedItemId, closeMenu]);
  useEffect6(() => {
    if (isMenuOpen && isMenuButtonFocused() && !selectedItemId) {
      focusOnNextItem();
    }
  }, [isMenuOpen, isMenuButtonFocused, selectedItemId, focusOnNextItem]);
  useEffect6(() => {
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onKeyDown]);
  return {
    isMenuOpen,
    menuButtonRef,
    menuItemRefs,
    openMenu,
    selectedItemId,
    setMenuItemRef,
    toggleMenuOpen,
    setSelectedItemId
  };
};

// src/components/action-menu/action-menu.styles.tsx
var ACTION_MENU_CLASS_NAMES = {
  ACTION_MENU: "GDS-action-menu",
  BUTTON: "GDS-action-menu-button",
  POPUP: "GDS-action-menu-popup",
  LIST: "GDS-action-menu-list",
  LABEL: "GDS-action-menu-label",
  LIST_ITEM: "GDS-action-menu-list-item"
};
var getCustomStylesForItem = (customStyles, itemClassName) => customStyles && customStyles[`.${itemClassName}`] ? customStyles[`.${itemClassName}`] : {};
var composeActionMenuStyles = (customStyles = {}) => {
  const { BUTTON, POPUP, LIST, LIST_ITEM, LABEL } = ACTION_MENU_CLASS_NAMES;
  const listItemStyles = {
    padding: "$threeQuarters $oneAndHalf",
    borderBottom: "solid $colors$onSurfaceBorderSubdued $borderWidths$thin",
    "&:last-child": {
      borderBottom: "none"
    }
  };
  return __spreadProps(__spreadValues({
    position: "relative",
    width: "max-content"
  }, customStyles), {
    [`.${BUTTON}`]: __spreadValues({
      '&[aria-expanded="false"] + .GDS-action-menu-popup': {
        display: "none"
      }
    }, getCustomStylesForItem(customStyles, BUTTON)),
    [`.${POPUP}`]: __spreadValues({
      position: "absolute",
      width: "max-content",
      height: "max-content",
      top: "calc(100% + $half)",
      insetInlineStart: "50%",
      transform: "translateX(-50%)",
      zIndex: "$dropdown",
      background: "$surfaceBackgroundPrimary",
      boxShadow: "$dropdown",
      borderRadius: "$huge"
    }, getCustomStylesForItem(customStyles, POPUP)),
    [`.${LIST}`]: __spreadValues({}, getCustomStylesForItem(customStyles, LIST)),
    [`.${LIST_ITEM}`]: __spreadValues(__spreadValues({}, listItemStyles), getCustomStylesForItem(customStyles, LIST_ITEM)),
    [`.${LABEL}`]: __spreadValues(__spreadValues({}, listItemStyles), getCustomStylesForItem(customStyles, LABEL))
  });
};

// src/components/action-menu/action-menu.component.tsx
var ActionMenu = ({
  className: customClassName = "",
  css: customCss = {},
  menuButton,
  menuId = "action-menu",
  menuItems = [],
  menuLabel = void 0,
  onSelectItem
}) => {
  const {
    isMenuOpen,
    menuButtonRef,
    selectedItemId,
    setMenuItemRef,
    toggleMenuOpen,
    setSelectedItemId
  } = useActionMenuControls();
  const menuButtonId = `${menuId}-button`;
  const menuLabelId = menuLabel ? `${menuId}-label` : "";
  const onClickMenuButton = () => {
    toggleMenuOpen();
  };
  const onClickMenuItem = (event) => {
    const selectedId = event.currentTarget.id;
    setSelectedItemId(selectedId);
  };
  const menuButtonProps = {
    id: menuButtonId,
    ref: menuButtonRef,
    onClick: onClickMenuButton,
    className: ACTION_MENU_CLASS_NAMES.BUTTON,
    "data-testid": "action-menu-button",
    "aria-controls": menuId,
    "aria-expanded": isMenuOpen,
    "aria-haspopup": true
  };
  const composedActionMenuStyles = composeActionMenuStyles(customCss);
  React81.useEffect(() => {
    if (selectedItemId !== void 0) {
      onSelectItem(selectedItemId);
      setSelectedItemId(void 0);
    }
  }, [selectedItemId, onSelectItem, setSelectedItemId]);
  return /* @__PURE__ */ React81.createElement(
    Box39,
    {
      css: composedActionMenuStyles,
      className: [ACTION_MENU_CLASS_NAMES.ACTION_MENU, customClassName].join(
        " "
      ),
      "data-testid": "action-menu"
    },
    React81.cloneElement(menuButton, menuButtonProps),
    /* @__PURE__ */ React81.createElement(
      Box39,
      {
        className: ACTION_MENU_CLASS_NAMES.POPUP,
        "data-testid": "action-menu-popup"
      },
      menuLabel && /* @__PURE__ */ React81.createElement(
        UtilityText2,
        {
          as: "div",
          className: ACTION_MENU_CLASS_NAMES.LABEL,
          "data-testid": "action-menu-label",
          emphasis: "emphasized",
          id: menuLabelId
        },
        menuLabel
      ),
      /* @__PURE__ */ React81.createElement(
        Box39,
        {
          "aria-describedby": menuLabelId,
          "aria-labelledby": menuButtonId,
          as: "ul",
          className: ACTION_MENU_CLASS_NAMES.LIST,
          id: menuId,
          role: "menu"
        },
        menuItems.map((item) => /* @__PURE__ */ React81.createElement(
          UtilityText2,
          {
            as: "li",
            className: ACTION_MENU_CLASS_NAMES.LIST_ITEM,
            id: item.id,
            key: item.id,
            onClick: onClickMenuItem,
            role: "menuitem",
            tabIndex: -1,
            ref: setMenuItemRef
          },
          item.label
        ))
      )
    )
  );
};

// src/components/switch/switch-indicator.component.tsx
import * as React82 from "react";
import * as RadixSwitch from "@radix-ui/react-switch";
import {
  styled as styled9,
  Icon as Icon10,
  Spinner as Spinner2,
  StackLayout as StackLayout12
} from "@leagueplatform/genesis-core";
var SwitchRoot = styled9(RadixSwitch.Root, {
  $$borderThickness: "2px",
  $$thumbSize: "20px",
  all: "unset",
  width: "$three",
  minWidth: "$three",
  height: "calc($$thumbSize + $$borderThickness*2)",
  backgroundColor: "$interactiveActionSubdued",
  borderRadius: "$pill",
  position: "relative",
  ".GDS-icon": {
    transition: "opacity $transitions$defaultTime"
  },
  "&:focus": {
    boxShadow: "0 0 0 $$borderThickness $interactiveActionPrimary"
  },
  '&[data-state="checked"]': {
    backgroundColor: "$interactiveActionPrimary",
    ".GDS-icon": {
      opacity: "1"
    }
  },
  '&[data-state="unchecked"]': {
    ".GDS-icon": {
      opacity: "0"
    }
  },
  "&[disabled]": {
    opacity: 0.5
  }
});
var SwitchThumb = styled9(RadixSwitch.Thumb, {
  display: "block",
  width: "$$thumbSize",
  height: "$$thumbSize",
  backgroundColor: "$interactiveBackgroundDefault",
  borderRadius: "$circle",
  transition: "transform $transitions$defaultTime",
  transform: "translateX($$borderThickness)",
  willChange: "transform",
  '&[data-state="checked"]': {
    transform: "translateX(calc($space$oneAndHalf + $$borderThickness))"
  }
});
var Wrapper = styled9("span", {
  variants: {
    loading: {
      true: {
        ".cc-switch-root": {
          backgroundColor: "$none"
        },
        ".cc-switch-thumb, .cc-switch-icon": {
          display: "none"
        }
      }
    }
  }
});
var SwitchIndicator = (_a) => {
  var _b = _a, {
    css: css20,
    className = "",
    id,
    checked,
    hideIcon,
    ariaLabelledBy,
    ariaLabel,
    ariaDisabled,
    loading,
    onChange
  } = _b, props = __objRest(_b, [
    "css",
    "className",
    "id",
    "checked",
    "hideIcon",
    "ariaLabelledBy",
    "ariaLabel",
    "ariaDisabled",
    "loading",
    "onChange"
  ]);
  return /* @__PURE__ */ React82.createElement(
    Wrapper,
    {
      loading,
      className: ["cc-switch-root-wrapper", className].join(" ")
    },
    /* @__PURE__ */ React82.createElement(
      SwitchRoot,
      __spreadValues({
        id,
        onCheckedChange: onChange,
        checked,
        "aria-labelledby": ariaLabelledBy,
        "aria-label": ariaLabel,
        "aria-disabled": ariaDisabled,
        className: "cc-switch-root"
      }, props),
      !hideIcon && /* @__PURE__ */ React82.createElement(
        Icon10,
        {
          icon: "interfaceCheckmark",
          className: "cc-switch-icon",
          "data-testid": "switch-icon",
          tint: "$interactiveIconDefault",
          css: {
            position: "absolute",
            top: "$none",
            insetInlineStart: "$$borderThickness"
          }
        }
      ),
      loading && /* @__PURE__ */ React82.createElement(
        StackLayout12,
        {
          css: { width: "$three", flex: "unset" },
          horizontalAlignment: "spaceAround",
          orientation: "horizontal"
        },
        /* @__PURE__ */ React82.createElement(Spinner2, { loading, size: "20px", "data-testid": "switch-spinner" })
      ),
      /* @__PURE__ */ React82.createElement(SwitchThumb, { className: "cc-switch-thumb" })
    )
  );
};

// src/components/switch/switch.component.tsx
import React83, { isValidElement } from "react";
import { styled as styled10 } from "@leagueplatform/genesis-core";
var LabelText2 = styled10("span", {
  typography: "$bodyOne",
  variants: {
    disabled: {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    },
    "aria-disabled": {
      true: { color: "$onSurfaceTextSubdued" },
      false: { color: "$onSurfaceTextPrimary" }
    }
  }
});
var SwitchLabel = styled10("label", {
  gap: "$half",
  borderRadius: "$medium",
  padding: "$half",
  variants: {
    layout: {
      row: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        "&:focus-within:has(button:focus)": {
          boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
          // Visible in Windows high-contrast themes
          outline: "$borderWidths$innerFocus  solid transparent",
          button: {
            '&[class*="cc-"]': {
              outline: "none"
            }
          }
        }
      },
      inline: {
        display: "inline-flex",
        "&:focus-within": {
          "&:focus-within:has(button:focus)": {
            boxShadow: "inset 0 0 0 $borderWidths$innerFocus $colors$interactiveFocusInner",
            // Visible in Windows high-contrast themes
            outline: "$borderWidths$innerFocus  solid transparent",
            button: {
              '&[class*="cc-"]': {
                outline: "none"
              }
            }
          }
        }
      }
    },
    disabled: {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    },
    "aria-disabled": {
      true: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  }
});
var Wrapper2 = styled10("div");
var Switch = (_a) => {
  var _b = _a, {
    label,
    layout = "inline",
    css: css20,
    id,
    checked,
    disabled,
    ariaDisabled,
    onClick,
    onChange,
    onBlur,
    onFocus
  } = _b, props = __objRest(_b, [
    "label",
    "layout",
    "css",
    "id",
    "checked",
    "disabled",
    "ariaDisabled",
    "onClick",
    "onChange",
    "onBlur",
    "onFocus"
  ]);
  const labelId = `${id}-label`;
  return layout === "row" ? /* @__PURE__ */ React83.createElement(Wrapper2, { className: "cc-switch-row", css: __spreadProps(__spreadValues({}, css20), { width: "100%" }) }, /* @__PURE__ */ React83.createElement(
    SwitchLabel,
    {
      className: "cc-switch-label",
      id: labelId,
      htmlFor: id,
      layout,
      disabled,
      "aria-disabled": ariaDisabled
    },
    /* @__PURE__ */ React83.createElement(
      LabelText2,
      {
        className: "cc-switch-label-text",
        disabled,
        "aria-disabled": ariaDisabled
      },
      label
    ),
    /* @__PURE__ */ React83.createElement(
      SwitchIndicator,
      __spreadValues({
        id,
        checked,
        disabled,
        "aria-disabled": ariaDisabled,
        ariaLabelledBy: labelId,
        onClick,
        onChange,
        onBlur,
        onFocus,
        css: {
          marginInlineStart: "$half"
        }
      }, props)
    )
  )) : /* @__PURE__ */ React83.createElement(Wrapper2, { className: "cc-switch-inline", css: __spreadValues({}, css20) }, /* @__PURE__ */ React83.createElement(
    SwitchLabel,
    {
      id: labelId,
      className: "cc-switch-label",
      htmlFor: id,
      layout,
      disabled,
      "aria-disabled": ariaDisabled
    },
    /* @__PURE__ */ React83.createElement(
      SwitchIndicator,
      __spreadValues({
        id,
        checked,
        disabled,
        "aria-disabled": ariaDisabled,
        ariaLabelledBy: labelId,
        onClick,
        onChange,
        onBlur,
        onFocus
      }, props)
    ),
    isValidElement(label) ? label : /* @__PURE__ */ React83.createElement(
      LabelText2,
      {
        className: "cc-switch-label-text",
        disabled,
        "aria-disabled": ariaDisabled
      },
      label
    )
  ));
};

// src/components/date-picker/date-picker.component.tsx
import * as React84 from "react";
import {
  DateInput as DateInput2,
  DatePicker as AriaDatePicker,
  DateSegment,
  Group,
  FieldError
} from "react-aria-components";
import {
  Popover,
  Box as Box40,
  TextInput as TextInput2,
  InputLabel,
  Icon as Icon11,
  Button as Button8
} from "@leagueplatform/genesis-core";
function DatePicker(_a) {
  var _b = _a, {
    label,
    description,
    errorMessage
  } = _b, props = __objRest(_b, [
    "label",
    "description",
    "errorMessage"
  ]);
  return /* @__PURE__ */ React84.createElement(
    Box40,
    {
      css: {
        ".GDS-base-input-wrapper": {
          display: "none"
        },
        ".GDS-text-input-wrapper": {
          flex: 1
        },
        button: {
          cursor: "pointer"
        },
        ".react-aria-DateInput": {
          display: "flex",
          ".react-aria-DateSegment:nth-child(6)": {
            marginInlineEnd: "$half"
          },
          ".react-aria-DateSegment:nth-child(11)": {
            marginInlineEnd: "$quarter"
          }
        },
        ".GDS-affix-leading-content": {
          width: "250px"
        },
        "@layer popover": {
          insetInlineStart: "-143px",
          button: {
            cursor: "pointer"
          },
          ".react-aria-Popover": {
            maxWidth: "unset",
            padding: "1.25rem"
          }
        }
      }
    },
    label && /* @__PURE__ */ React84.createElement(InputLabel, { htmlFor: "date-picker", required: true }, label),
    /* @__PURE__ */ React84.createElement(AriaDatePicker, __spreadValues({}, props), /* @__PURE__ */ React84.createElement(
      TextInput2,
      {
        id: "date-picker",
        css: {
          ".react-aria-Group": {
            width: "100%"
          }
        },
        leadingContent: /* @__PURE__ */ React84.createElement(Group, null, /* @__PURE__ */ React84.createElement(DateInput2, null, (segment) => /* @__PURE__ */ React84.createElement(DateSegment, { segment }))),
        addOnEnd: /* @__PURE__ */ React84.createElement(Popover.Root, null, /* @__PURE__ */ React84.createElement(Popover.Trigger, null, /* @__PURE__ */ React84.createElement(
          Button8,
          {
            "aria-label": "Open calendar pop out",
            priority: "primary",
            size: "medium",
            css: {
              borderRadius: "0 $radii$medium $radii$medium 0",
              flexShrink: 0,
              "&:disabled": {
                borderColor: "$interactiveBorderDefault",
                borderInlineStart: "none"
              }
            },
            disabled: props.isReadOnly
          },
          /* @__PURE__ */ React84.createElement(Icon11, { icon: "descriptiveCalendar" })
        )), /* @__PURE__ */ React84.createElement(
          Popover.Content,
          {
            headingBar: false,
            showCloseButton: false,
            align: "end",
            css: {
              position: "relative",
              zIndex: "999999999"
            }
          },
          /* @__PURE__ */ React84.createElement(
            CalendarView,
            {
              css: {
                ".calendar": {
                  width: "300px"
                },
                ".calendar-grid-cell": {
                  width: "22px",
                  height: "22px"
                },
                ".react-aria-CalendarHeaderCell": {
                  padding: "$half"
                },
                ".calendar .calendar-grid-cell": {
                  padding: "$one",
                  margin: "$half auto",
                  border: "1px solid transparent",
                  borderRadius: "100%",
                  "&:hover": {
                    backgroundColor: "$interactiveActionHovered",
                    color: "$onSurfaceTextReversed"
                  },
                  "&:focus-visible": {
                    border: "1px solid $interactiveFocusInner"
                  },
                  "&:active": {
                    backgroundColor: "$interactiveActionPressed",
                    color: "$onSurfaceTextReversed"
                  },
                  "&.calendar-grid-cell[data-selected]": {
                    backgroundColor: "$interactiveActionPrimary",
                    color: "$onSurfaceTextReversed",
                    outline: "1px solid $interactiveActionPrimary",
                    boxShadow: "none"
                  }
                }
              }
            }
          )
        )),
        readOnly: props.isReadOnly
      }
    ), /* @__PURE__ */ React84.createElement(FieldError, null, errorMessage))
  );
}

// src/components/pagination-container/pagination-container.component.tsx
import * as React85 from "react";
import {
  Box as Box41,
  focusOutlineOuter
} from "@leagueplatform/genesis-core";
var PaginationContainer = React85.forwardRef(
  ({ children, css: css20, scrollOffset = "$three", selectedPage, labelId = "" }, _ref) => {
    const [currentPage, setCurrentPage] = React85.useState(selectedPage);
    const [isFocusing, setIsFocusing] = React85.useState(false);
    const ref = React85.useRef(null);
    const containerRef = _ref != null ? _ref : ref;
    React85.useEffect(() => {
      var _a, _b;
      if (selectedPage !== currentPage) {
        setCurrentPage(selectedPage);
        setIsFocusing(true);
      }
      if (isFocusing) {
        (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.focus();
        (_b = ref.current) == null ? void 0 : _b.scrollIntoView({ behavior: "smooth" });
        setIsFocusing(false);
      }
    }, [currentPage, isFocusing, selectedPage]);
    return /* @__PURE__ */ React85.createElement(
      Box41,
      {
        "aria-labelledby": labelId,
        css: __spreadValues({
          scrollMarginBlockStart: scrollOffset,
          "&&:focus": {
            outline: "none"
          },
          "&&:focus-visible": __spreadValues({}, focusOutlineOuter)
        }, css20),
        tabIndex: -1,
        ref: containerRef,
        "aria-live": "polite",
        as: "section"
      },
      children
    );
  }
);

// src/components/impersonation-top-banner/impersonation-top-banner.component.tsx
import React86 from "react";
import { useIntl as useIntl24 } from "@leagueplatform/locales";
import {
  Box as Box42,
  HeadingText as HeadingText5,
  Icon as Icon12,
  StackLayout as StackLayout13,
  Button as Button9
} from "@leagueplatform/genesis-core";
import { useGetUserProfile } from "@leagueplatform/web-common";
import { useGetIsImpersonator as useGetIsImpersonator2 } from "@leagueplatform/auth-utils";
var ImpersonationTopBanner = () => {
  const { formatMessage } = useIntl24();
  const isImpersonation = useGetIsImpersonator2();
  const { data: userProfileData } = useGetUserProfile();
  const { firstName, preferredFirstName, lastName } = (userProfileData == null ? void 0 : userProfileData.userProfile) || {};
  const memberName = preferredFirstName ? `${preferredFirstName} ${lastName}` : `${firstName} ${lastName}`;
  if (!isImpersonation) {
    return null;
  }
  return /* @__PURE__ */ React86.createElement(
    StackLayout13,
    {
      orientation: "horizontal",
      horizontalAlignment: "spaceEvenly",
      verticalAlignment: "center",
      css: {
        padding: "$one",
        backgroundColor: "$warningBackgroundSubdued",
        flexWrap: "wrap"
      }
    },
    /* @__PURE__ */ React86.createElement(Box42, null, /* @__PURE__ */ React86.createElement(StackLayout13, { orientation: "horizontal", verticalAlignment: "center" }, /* @__PURE__ */ React86.createElement(
      Icon12,
      {
        icon: "descriptiveLockShield",
        size: "$oneAndHalf",
        tint: "$interactiveIconDisabled"
      }
    ), /* @__PURE__ */ React86.createElement(
      HeadingText5,
      {
        as: "p",
        level: "display",
        size: "sm",
        css: { typography: "$subtitleOne", paddingInlineStart: "$half" }
      },
      formatMessage(
        { id: "CSE_IMPERSONATION_BANNER_TEXT" },
        { memberName }
      )
    ))),
    /* @__PURE__ */ React86.createElement(
      Button9,
      {
        priority: "primary",
        as: "a",
        href: "/sign-out",
        icon: "interfaceSignOut"
      },
      formatMessage({ id: "CSE_END_IMPERSONATION_MODE" })
    )
  );
};

// src/components/impersonation-masonry-banner/impersonation-masonry-banner.component.tsx
import React87 from "react";
import { useIntl as useIntl25 } from "@leagueplatform/locales";
import { StatusBanner, ParagraphText as ParagraphText4 } from "@leagueplatform/genesis-core";
import { useGetIsImpersonator as useGetIsImpersonator3 } from "@leagueplatform/auth-utils";
var ImpersonationMasonryBanner = () => {
  const { formatMessage } = useIntl25();
  const isImpersonation = useGetIsImpersonator3();
  if (!isImpersonation) {
    return null;
  }
  return /* @__PURE__ */ React87.createElement(PageContainer, null, /* @__PURE__ */ React87.createElement(
    StatusBanner,
    {
      css: { margin: "$twoAndHalf 0" },
      showIcon: true,
      status: "warning",
      title: formatMessage({ id: "CSE_IMPERSONATION_MASONRY_HEADER" })
    },
    /* @__PURE__ */ React87.createElement(ParagraphText4, { css: { typography: "$bodyTwo" } }, formatMessage({ id: "CSE_IMPERSONATION_MASONRY_MESSAGE" }))
  ));
};

// src/index.ts
initModule();
export {
  Accordion,
  ActionMenu,
  AppBarComponent,
  AppBarHeader,
  AppBarItem,
  AppBarLink,
  AppBarNav,
  AppBarNavLink,
  AppBarNavList,
  AppleAppIcon,
  AssessmentExitModal,
  Avatar,
  BackButtonArrow,
  Badge,
  CHECKBOX,
  CONTENT_MAX_WIDTH,
  CTAMediaObject,
  CalendarView,
  CalloutBanner,
  CardBanner,
  Carousel,
  ConditionalLink,
  ConditionalLinkCard,
  DATE,
  DatePicker,
  DimensionOfHealthModal,
  DocumentCard,
  ErrorState,
  ExternalRedirect,
  EyebrowEarnPoints,
  FadeAndGrow,
  FadeIn,
  FeedbackCard,
  FieldGrid,
  FieldSection,
  FieldWrapper,
  FullPageError,
  GenesisRouterLink,
  GoogleAppIcon,
  Grow,
  HIDDEN,
  HighlightBanner,
  HighlightCard,
  IconText,
  ImpersonationMasonryBanner,
  ImpersonationTopBanner,
  InputField,
  InternalOrExternalLink,
  InternalOrExternalLinkButton,
  LanguageSelector,
  LoadingIndicator,
  MULTISELECT,
  MainPageContainer,
  MaxWidthWrapper,
  NoPeekCarousel,
  OpensInANewTabMessage,
  PageContainer,
  PageHeaderBackground,
  PageNotFound,
  PaginationContainer,
  PillTab,
  PillTabList,
  PillTabs,
  ProfileModal,
  ProgressBar,
  ProgressRing,
  RADIO,
  SELECT,
  SIDEBAR_MIN_WIDTH,
  STATUS_OPTIONS,
  Sidebar,
  SidebarCard,
  SkeletonBox,
  SkeletonCards,
  SlideInHorizontal,
  StackLayout3 as StackLayout,
  StatusBadge,
  Switch,
  SwitchIndicator,
  SwoopHeader,
  TEXT,
  UserDropdownComponent,
  VeryQuietButton,
  WithHiddenDescription,
  addSidebarSpacing,
  useDisplayIsImpersonatorError
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/web-common-components'] = window.leagueSDKsPresent['@leagueplatform/web-common-components'] || [];
    window.leagueSDKsPresent['@leagueplatform/web-common-components'].push('2.22.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/web-common-components'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/web-common-components module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map